var _defs, _rect, _image, _image2, _path, _path2, _image3, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _polygon, _path12, _path13, _path14, _polygon2, _path15, _polygon3, _polygon4, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _path16, _path17, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _path18, _path19, _polygon20, _path20, _path21, _path22, _path23, _polygon21, _polygon22, _path24, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _path25, _polygon37, _path26, _path27, _path28, _path29, _path30, _path31, _polygon38, _path32, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _polygon45, _g, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _rect2, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _polygon79, _path53, _path54, _path55, _polygon80, _path56, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _path57, _path58, _polygon93, _polygon94, _polygon95, _polygon96, _polygon97, _path59, _path60, _polygon98, _path61, _path62, _path63, _path64, _polygon99, _polygon100, _path65, _polygon101, _polygon102, _polygon103, _polygon104, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _path66, _polygon115, _path67, _path68, _path69, _path70, _path71, _path72, _polygon116, _path73, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _polygon123, _g2, _polygon124, _polygon125, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _rect3, _path85, _path86, _path87, _path88;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg13D(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 164.57 233.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#231f20;}.cls-3{fill:#f16148;}.cls-4{fill:#bc141a;}.cls-5{fill:#cc1217;}.cls-6{fill:#ed1c24;}.cls-7{fill:url(#linear-gradient);}.cls-8{fill:#fde4e0;}.cls-9{fill:#6b6c6f;}.cls-10{fill:url(#linear-gradient-2);}.cls-11{fill:url(#linear-gradient-3);}.cls-12{fill:url(#linear-gradient-4);}.cls-13{fill:url(#linear-gradient-5);}.cls-14{fill:url(#linear-gradient-6);}.cls-15{fill:url(#linear-gradient-7);}.cls-16{fill:url(#linear-gradient-8);}.cls-17{fill:#fff;}.cls-18{fill:url(#linear-gradient-9);}.cls-19{fill:url(#linear-gradient-10);}.cls-20{fill:url(#linear-gradient-11);}.cls-21{fill:url(#linear-gradient-12);}.cls-22{fill:#515254;}.cls-23{fill:url(#linear-gradient-13);}.cls-24{fill:url(#linear-gradient-14);}.cls-25{clip-path:url(#clip-path);}.cls-26{fill:url(#linear-gradient-15);}.cls-27{fill:url(#linear-gradient-16);}.cls-28{fill:url(#linear-gradient-17);}.cls-29{fill:url(#linear-gradient-18);}.cls-30{fill:url(#linear-gradient-19);}.cls-31{fill:url(#linear-gradient-20);}.cls-32{fill:url(#linear-gradient-21);}.cls-33{fill:url(#linear-gradient-22);}.cls-34{fill:url(#linear-gradient-23);}.cls-35{fill:url(#linear-gradient-24);}.cls-36{fill:url(#linear-gradient-25);}.cls-37{fill:url(#linear-gradient-26);}.cls-38{fill:url(#linear-gradient-27);}.cls-39{fill:url(#linear-gradient-28);}.cls-40{fill:url(#linear-gradient-29);}.cls-41{fill:url(#linear-gradient-30);}.cls-42{fill:url(#linear-gradient-31);}.cls-43{fill:url(#linear-gradient-32);}.cls-44{fill:url(#linear-gradient-33);}.cls-45{fill:url(#linear-gradient-34);}.cls-46{fill:url(#linear-gradient-35);}.cls-47{fill:url(#linear-gradient-36);}.cls-48{fill:url(#linear-gradient-37);}.cls-49{fill:url(#linear-gradient-38);}.cls-50{fill:url(#linear-gradient-39);}.cls-51{fill:url(#linear-gradient-40);}.cls-52{fill:url(#linear-gradient-41);}.cls-53{fill:url(#linear-gradient-42);}.cls-54{fill:url(#linear-gradient-43);}.cls-55{fill:url(#linear-gradient-44);}.cls-56{fill:url(#linear-gradient-45);}.cls-57{fill:url(#linear-gradient-46);}.cls-58{fill:url(#linear-gradient-47);}.cls-59{fill:url(#linear-gradient-48);}.cls-60{fill:url(#linear-gradient-49);}.cls-61{fill:url(#linear-gradient-50);}.cls-62{fill:url(#linear-gradient-51);}.cls-63{fill:url(#linear-gradient-52);}.cls-64{fill:url(#linear-gradient-53);}.cls-65{fill:url(#linear-gradient-54);}.cls-66{fill:url(#linear-gradient-55);}.cls-67{fill:url(#linear-gradient-56);}.cls-68{fill:url(#linear-gradient-57);}.cls-69{fill:url(#linear-gradient-58);}.cls-70{fill:url(#linear-gradient-59);}.cls-71{fill:url(#linear-gradient-60);}.cls-72{fill:url(#linear-gradient-61);}.cls-73{fill:url(#linear-gradient-62);}.cls-74{fill:url(#linear-gradient-63);}.cls-75{fill:url(#linear-gradient-64);}.cls-76{fill:url(#linear-gradient-65);}.cls-77{fill:url(#linear-gradient-66);}.cls-78{fill:url(#linear-gradient-67);}.cls-79{fill:url(#linear-gradient-68);}.cls-80{fill:url(#linear-gradient-69);}.cls-81{fill:url(#linear-gradient-70);}.cls-82{fill:url(#linear-gradient-71);}.cls-83{fill:url(#linear-gradient-72);}.cls-84{fill:url(#linear-gradient-73);}.cls-85{fill:url(#linear-gradient-74);}.cls-86{fill:url(#linear-gradient-75);}.cls-87{fill:url(#linear-gradient-76);}.cls-88{fill:url(#linear-gradient-77);}.cls-89{fill:url(#linear-gradient-78);}.cls-90{fill:url(#linear-gradient-79);}.cls-91{fill:url(#linear-gradient-80);}.cls-92{fill:url(#linear-gradient-81);}.cls-93{fill:url(#linear-gradient-82);}.cls-94{fill:url(#linear-gradient-83);}.cls-95{fill:url(#linear-gradient-84);}.cls-96{fill:url(#linear-gradient-85);}.cls-97{fill:url(#linear-gradient-86);}.cls-98{fill:url(#linear-gradient-87);}.cls-99{fill:url(#linear-gradient-88);}.cls-100{fill:url(#linear-gradient-89);}.cls-101{fill:url(#linear-gradient-90);}.cls-102{fill:url(#linear-gradient-91);}.cls-103{fill:url(#linear-gradient-92);}.cls-104{fill:url(#linear-gradient-93);}.cls-105{fill:url(#linear-gradient-94);}.cls-106{fill:url(#linear-gradient-95);}.cls-107{fill:url(#linear-gradient-96);}.cls-108{fill:url(#linear-gradient-97);}.cls-109{fill:url(#linear-gradient-98);}.cls-110{fill:url(#linear-gradient-99);}.cls-111{fill:url(#linear-gradient-100);}.cls-112{fill:url(#linear-gradient-101);}.cls-113{fill:url(#linear-gradient-102);}.cls-114{fill:url(#linear-gradient-103);}.cls-115{fill:url(#linear-gradient-104);}.cls-116{fill:url(#linear-gradient-105);}.cls-117{fill:url(#linear-gradient-106);}.cls-118{fill:url(#linear-gradient-107);}.cls-119{fill:url(#linear-gradient-108);}.cls-120{fill:url(#linear-gradient-109);}.cls-121{fill:url(#linear-gradient-110);}.cls-122{fill:url(#linear-gradient-111);}.cls-123{fill:url(#linear-gradient-112);}.cls-124{fill:url(#linear-gradient-113);}.cls-125{fill:url(#linear-gradient-114);}.cls-126{fill:url(#linear-gradient-115);}.cls-127{fill:url(#linear-gradient-116);}.cls-128{fill:url(#linear-gradient-117);}.cls-129{fill:url(#linear-gradient-118);}.cls-130{fill:url(#linear-gradient-119);}.cls-131{fill:url(#linear-gradient-120);}.cls-132{fill:url(#linear-gradient-121);}.cls-133{fill:url(#linear-gradient-122);}.cls-134{fill:url(#linear-gradient-123);}.cls-135{fill:url(#linear-gradient-124);}.cls-136{fill:url(#linear-gradient-125);}.cls-137{fill:url(#linear-gradient-126);}.cls-138{fill:url(#linear-gradient-127);}.cls-139{fill:url(#linear-gradient-128);}.cls-140{fill:url(#linear-gradient-129);}.cls-141{fill:url(#linear-gradient-130);}.cls-142{fill:url(#linear-gradient-131);}.cls-143{fill:url(#linear-gradient-132);}.cls-144{fill:url(#linear-gradient-133);}.cls-145{fill:url(#linear-gradient-134);}.cls-146{fill:url(#linear-gradient-135);}.cls-147{fill:url(#linear-gradient-136);}.cls-148{fill:url(#linear-gradient-137);}.cls-149{fill:url(#linear-gradient-138);}.cls-150{fill:url(#linear-gradient-139);}.cls-151{fill:url(#linear-gradient-140);}.cls-152{fill:url(#linear-gradient-141);}.cls-153{fill:url(#linear-gradient-142);}.cls-154{fill:url(#linear-gradient-143);}.cls-155{fill:url(#linear-gradient-144);}.cls-156{fill:url(#linear-gradient-145);}.cls-157{fill:url(#linear-gradient-146);}.cls-158{fill:url(#linear-gradient-147);}.cls-159{fill:url(#linear-gradient-148);}.cls-160{fill:url(#linear-gradient-149);}.cls-161{fill:url(#linear-gradient-150);}.cls-162{fill:url(#linear-gradient-151);}.cls-163{fill:url(#linear-gradient-152);}.cls-164{fill:url(#linear-gradient-153);}.cls-165{fill:url(#linear-gradient-154);}.cls-166{fill:url(#linear-gradient-155);}.cls-167{fill:url(#linear-gradient-156);}.cls-168{fill:url(#linear-gradient-157);}.cls-169{fill:url(#linear-gradient-158);}.cls-170{fill:url(#linear-gradient-159);}.cls-171{fill:url(#linear-gradient-160);}.cls-172{fill:url(#linear-gradient-161);}.cls-173{fill:url(#linear-gradient-162);}.cls-174{fill:url(#linear-gradient-163);}.cls-175{fill:url(#linear-gradient-164);}.cls-176{fill:url(#linear-gradient-165);}.cls-177{fill:url(#linear-gradient-166);}.cls-178{fill:url(#linear-gradient-167);}.cls-179{fill:url(#linear-gradient-168);}.cls-180{fill:url(#linear-gradient-169);}.cls-181{fill:url(#linear-gradient-170);}.cls-182{fill:url(#linear-gradient-171);}.cls-183{fill:url(#linear-gradient-172);}.cls-184{fill:url(#linear-gradient-173);}.cls-185{fill:url(#linear-gradient-174);}.cls-186{fill:url(#linear-gradient-175);}.cls-187{fill:url(#linear-gradient-176);}.cls-188{fill:url(#linear-gradient-177);}.cls-189{fill:url(#linear-gradient-178);}.cls-190{fill:url(#linear-gradient-179);}.cls-191{fill:url(#linear-gradient-180);}.cls-192{fill:url(#linear-gradient-181);}.cls-193{fill:url(#linear-gradient-182);}.cls-194{fill:url(#linear-gradient-183);}.cls-195{fill:url(#linear-gradient-184);}.cls-196{fill:url(#linear-gradient-185);}.cls-197{fill:url(#linear-gradient-186);}.cls-198{fill:url(#linear-gradient-187);}.cls-199{fill:url(#linear-gradient-188);}.cls-200{fill:url(#linear-gradient-189);}.cls-201{fill:url(#linear-gradient-190);}.cls-202{fill:url(#linear-gradient-191);}.cls-203{fill:url(#linear-gradient-192);}.cls-204{fill:url(#linear-gradient-193);}.cls-205{fill:url(#linear-gradient-194);}.cls-206{fill:url(#linear-gradient-195);}.cls-207{fill:url(#linear-gradient-196);}.cls-208{fill:url(#linear-gradient-197);}.cls-209{fill:url(#linear-gradient-198);}.cls-210{fill:url(#linear-gradient-199);}.cls-211{fill:url(#linear-gradient-200);}.cls-212{fill:url(#linear-gradient-201);}.cls-213{fill:url(#linear-gradient-202);}.cls-214{fill:url(#linear-gradient-203);}.cls-215{fill:url(#linear-gradient-204);}.cls-216{fill:url(#linear-gradient-205);}.cls-217{fill:url(#linear-gradient-206);}.cls-218{fill:url(#linear-gradient-207);}.cls-219{fill:url(#linear-gradient-208);}.cls-220{fill:url(#linear-gradient-209);}.cls-221{fill:url(#linear-gradient-210);}.cls-222{fill:url(#linear-gradient-211);}.cls-223{fill:url(#linear-gradient-212);}.cls-224{fill:url(#linear-gradient-213);}.cls-225{fill:url(#linear-gradient-214);}.cls-226{fill:url(#linear-gradient-215);}.cls-227{fill:url(#linear-gradient-216);}.cls-228{fill:url(#linear-gradient-217);}.cls-229{fill:url(#linear-gradient-218);}.cls-230{fill:url(#linear-gradient-219);}.cls-231{fill:url(#linear-gradient-220);}.cls-232{fill:url(#linear-gradient-221);}.cls-233{fill:url(#linear-gradient-222);}.cls-234{fill:url(#linear-gradient-223);}.cls-235{fill:url(#linear-gradient-224);}.cls-236{fill:url(#linear-gradient-225);}.cls-237{fill:url(#linear-gradient-226);}.cls-238{fill:url(#linear-gradient-227);}.cls-239{fill:url(#linear-gradient-228);}.cls-240{fill:url(#linear-gradient-229);}.cls-241{fill:url(#linear-gradient-230);}.cls-242{fill:url(#linear-gradient-231);}.cls-243{fill:url(#linear-gradient-232);}.cls-244{fill:url(#linear-gradient-233);}.cls-245{fill:url(#linear-gradient-234);}.cls-246{fill:url(#linear-gradient-235);}.cls-247{fill:url(#linear-gradient-236);}.cls-248{fill:url(#linear-gradient-237);}.cls-249{fill:url(#linear-gradient-238);}.cls-250{fill:url(#linear-gradient-239);}.cls-251{fill:url(#linear-gradient-240);}.cls-252{fill:url(#linear-gradient-241);}.cls-253{fill:url(#linear-gradient-242);}.cls-254{fill:url(#linear-gradient-243);}.cls-255{fill:url(#linear-gradient-244);}.cls-256{fill:url(#linear-gradient-245);}.cls-257{fill:url(#linear-gradient-246);}.cls-258{fill:url(#linear-gradient-247);}.cls-259{fill:url(#linear-gradient-248);}.cls-260{fill:url(#linear-gradient-249);}.cls-261{fill:url(#linear-gradient-250);}.cls-262{fill:url(#linear-gradient-251);}.cls-263{fill:url(#linear-gradient-252);}.cls-264{fill:url(#linear-gradient-253);}.cls-265{fill:url(#linear-gradient-254);}.cls-266{fill:url(#linear-gradient-255);}.cls-267{fill:url(#linear-gradient-256);}.cls-268{fill:url(#linear-gradient-257);}.cls-269{fill:url(#linear-gradient-258);}.cls-270{fill:url(#linear-gradient-259);}.cls-271{fill:url(#linear-gradient-260);}.cls-272{fill:url(#linear-gradient-261);}.cls-273{fill:url(#linear-gradient-262);}.cls-274{fill:url(#linear-gradient-263);}.cls-275{fill:url(#linear-gradient-264);}.cls-276{fill:url(#linear-gradient-265);}.cls-277{fill:url(#linear-gradient-266);}.cls-278{fill:url(#linear-gradient-267);}.cls-279{fill:url(#linear-gradient-268);}.cls-280{fill:url(#linear-gradient-269);}.cls-281{fill:url(#linear-gradient-270);}.cls-282{fill:url(#linear-gradient-271);}.cls-283{fill:url(#linear-gradient-272);}.cls-284{fill:url(#linear-gradient-273);}.cls-285{fill:url(#linear-gradient-274);}.cls-286{fill:url(#linear-gradient-275);}.cls-287{fill:url(#linear-gradient-276);}.cls-288{clip-path:url(#clip-path-2);}.cls-289{fill:url(#linear-gradient-277);}.cls-290{fill:url(#linear-gradient-278);}.cls-291{fill:url(#linear-gradient-279);}.cls-292{fill:url(#linear-gradient-280);}.cls-293{fill:url(#linear-gradient-281);}.cls-294{fill:url(#linear-gradient-282);}.cls-295{fill:url(#linear-gradient-283);}.cls-296{fill:url(#linear-gradient-284);}.cls-297{fill:url(#linear-gradient-285);}.cls-298{fill:url(#linear-gradient-286);}.cls-299{fill:url(#linear-gradient-287);}.cls-300{fill:url(#linear-gradient-288);}.cls-301{fill:url(#linear-gradient-289);}.cls-302{fill:url(#linear-gradient-290);}.cls-303{fill:url(#linear-gradient-291);}.cls-304{fill:url(#linear-gradient-292);}.cls-305{fill:url(#linear-gradient-293);}.cls-306{fill:url(#linear-gradient-294);}.cls-307{fill:url(#linear-gradient-295);}.cls-308{fill:url(#linear-gradient-296);}.cls-309{fill:url(#linear-gradient-297);}.cls-310{fill:url(#linear-gradient-298);}.cls-311{fill:url(#linear-gradient-299);}.cls-312{fill:url(#linear-gradient-300);}.cls-313{fill:url(#linear-gradient-301);}.cls-314{fill:url(#linear-gradient-302);}.cls-315{fill:url(#linear-gradient-303);}.cls-316{fill:url(#linear-gradient-304);}.cls-317{fill:url(#linear-gradient-305);}.cls-318{fill:url(#linear-gradient-306);}.cls-319{fill:url(#linear-gradient-307);}.cls-320{fill:url(#linear-gradient-308);}.cls-321{fill:url(#linear-gradient-309);}.cls-322{fill:url(#linear-gradient-310);}.cls-323{fill:url(#linear-gradient-311);}.cls-324{fill:url(#linear-gradient-312);}.cls-325{fill:url(#linear-gradient-313);}.cls-326{fill:url(#linear-gradient-314);}.cls-327{fill:url(#linear-gradient-315);}.cls-328{fill:url(#linear-gradient-316);}.cls-329{fill:url(#linear-gradient-317);}.cls-330{fill:url(#linear-gradient-318);}.cls-331{fill:url(#linear-gradient-319);}.cls-332{fill:url(#linear-gradient-320);}.cls-333{fill:url(#linear-gradient-321);}.cls-334{fill:url(#linear-gradient-322);}.cls-335{fill:url(#linear-gradient-323);}.cls-336{fill:url(#linear-gradient-324);}.cls-337{fill:url(#linear-gradient-325);}.cls-338{fill:url(#linear-gradient-326);}.cls-339{fill:url(#linear-gradient-327);}.cls-340{fill:url(#linear-gradient-328);}.cls-341{fill:url(#linear-gradient-329);}.cls-342{fill:url(#linear-gradient-330);}.cls-343{fill:url(#linear-gradient-331);}.cls-344{fill:url(#linear-gradient-332);}.cls-345{fill:url(#linear-gradient-333);}.cls-346{fill:url(#linear-gradient-334);}.cls-347{fill:url(#linear-gradient-335);}.cls-348{fill:url(#linear-gradient-336);}.cls-349{fill:url(#linear-gradient-337);}.cls-350{fill:url(#linear-gradient-338);}.cls-351{fill:url(#linear-gradient-339);}.cls-352{fill:url(#linear-gradient-340);}.cls-353{fill:url(#linear-gradient-341);}.cls-354{fill:url(#linear-gradient-342);}.cls-355{fill:url(#linear-gradient-343);}.cls-356{fill:url(#linear-gradient-344);}.cls-357{fill:url(#linear-gradient-345);}.cls-358{fill:url(#linear-gradient-346);}.cls-359{fill:url(#linear-gradient-347);}.cls-360{fill:url(#linear-gradient-348);}.cls-361{fill:url(#linear-gradient-349);}.cls-362{fill:url(#linear-gradient-350);}.cls-363{fill:url(#linear-gradient-351);}.cls-364{fill:url(#linear-gradient-352);}.cls-365{fill:url(#linear-gradient-353);}.cls-366{fill:url(#linear-gradient-354);}.cls-367{fill:url(#linear-gradient-355);}.cls-368{fill:url(#linear-gradient-356);}.cls-369{fill:url(#linear-gradient-357);}.cls-370{fill:url(#linear-gradient-358);}.cls-371{fill:url(#linear-gradient-359);}.cls-372{fill:url(#linear-gradient-360);}.cls-373{fill:url(#linear-gradient-361);}.cls-374{fill:url(#linear-gradient-362);}.cls-375{fill:url(#linear-gradient-363);}.cls-376{fill:url(#linear-gradient-364);}.cls-377{fill:url(#linear-gradient-365);}.cls-378{fill:url(#linear-gradient-366);}.cls-379{fill:url(#linear-gradient-367);}.cls-380{fill:url(#linear-gradient-368);}.cls-381{fill:url(#linear-gradient-369);}.cls-382{fill:url(#linear-gradient-370);}.cls-383{fill:url(#linear-gradient-371);}.cls-384{fill:url(#linear-gradient-372);}.cls-385{fill:url(#linear-gradient-373);}.cls-386{fill:url(#linear-gradient-374);}.cls-387{fill:url(#linear-gradient-375);}.cls-388{fill:url(#linear-gradient-376);}.cls-389{fill:url(#linear-gradient-377);}.cls-390{fill:url(#linear-gradient-378);}.cls-391{fill:url(#linear-gradient-379);}.cls-392{fill:url(#linear-gradient-380);}.cls-393{fill:url(#linear-gradient-381);}.cls-394{fill:url(#linear-gradient-382);}.cls-395{fill:url(#linear-gradient-383);}.cls-396{fill:url(#linear-gradient-384);}.cls-397{fill:url(#linear-gradient-385);}.cls-398{fill:url(#linear-gradient-386);}.cls-399{fill:url(#linear-gradient-387);}.cls-400{fill:url(#linear-gradient-388);}.cls-401{fill:url(#linear-gradient-389);}.cls-402{fill:url(#linear-gradient-390);}.cls-403{fill:url(#linear-gradient-391);}.cls-404{fill:url(#linear-gradient-392);}.cls-405{fill:url(#linear-gradient-393);}.cls-406{fill:url(#linear-gradient-394);}.cls-407{fill:url(#linear-gradient-395);}.cls-408{fill:url(#linear-gradient-396);}.cls-409{fill:url(#linear-gradient-397);}.cls-410{fill:url(#linear-gradient-398);}.cls-411{fill:url(#linear-gradient-399);}.cls-412{fill:url(#linear-gradient-400);}.cls-413{fill:url(#linear-gradient-401);}.cls-414{fill:url(#linear-gradient-402);}.cls-415{fill:url(#linear-gradient-403);}.cls-416{fill:url(#linear-gradient-404);}.cls-417{fill:url(#linear-gradient-405);}.cls-418{fill:url(#linear-gradient-406);}.cls-419{fill:url(#linear-gradient-407);}.cls-420{fill:url(#linear-gradient-408);}.cls-421{fill:url(#linear-gradient-409);}.cls-422{fill:url(#linear-gradient-410);}.cls-423{fill:url(#linear-gradient-411);}.cls-424{fill:url(#linear-gradient-412);}.cls-425{fill:url(#linear-gradient-413);}.cls-426{fill:url(#linear-gradient-414);}.cls-427{fill:url(#linear-gradient-415);}.cls-428{fill:url(#linear-gradient-416);}.cls-429{fill:url(#linear-gradient-417);}.cls-430{fill:url(#linear-gradient-418);}.cls-431{fill:url(#linear-gradient-419);}.cls-432{fill:url(#linear-gradient-420);}.cls-433{fill:url(#linear-gradient-421);}.cls-434{fill:url(#linear-gradient-422);}.cls-435{fill:url(#linear-gradient-423);}.cls-436{fill:url(#linear-gradient-424);}.cls-437{fill:url(#linear-gradient-425);}.cls-438{fill:url(#linear-gradient-426);}.cls-439{fill:url(#linear-gradient-427);}.cls-440{fill:url(#linear-gradient-428);}.cls-441{fill:url(#linear-gradient-429);}.cls-442{fill:url(#linear-gradient-430);}.cls-443{fill:url(#linear-gradient-431);}.cls-444{fill:url(#linear-gradient-432);}.cls-445{fill:url(#linear-gradient-433);}.cls-446{fill:url(#linear-gradient-434);}.cls-447{fill:url(#linear-gradient-435);}.cls-448{fill:url(#linear-gradient-436);}.cls-449{fill:url(#linear-gradient-437);}.cls-450{fill:url(#linear-gradient-438);}.cls-451{fill:url(#linear-gradient-439);}.cls-452{fill:url(#linear-gradient-440);}.cls-453{fill:url(#linear-gradient-441);}.cls-454{fill:url(#linear-gradient-442);}.cls-455{fill:url(#linear-gradient-443);}.cls-456{fill:url(#linear-gradient-444);}.cls-457{fill:url(#linear-gradient-445);}.cls-458{fill:url(#linear-gradient-446);}.cls-459{fill:url(#linear-gradient-447);}.cls-460{fill:url(#linear-gradient-448);}.cls-461{fill:url(#linear-gradient-449);}.cls-462{fill:url(#linear-gradient-450);}.cls-463{fill:url(#linear-gradient-451);}.cls-464{fill:url(#linear-gradient-452);}.cls-465{fill:url(#linear-gradient-453);}.cls-466{fill:url(#linear-gradient-454);}.cls-467{fill:url(#linear-gradient-455);}.cls-468{fill:url(#linear-gradient-456);}.cls-469{fill:url(#linear-gradient-457);}.cls-470{fill:url(#linear-gradient-458);}.cls-471{fill:url(#linear-gradient-459);}.cls-472{fill:url(#linear-gradient-460);}.cls-473{fill:url(#linear-gradient-461);}.cls-474{fill:url(#linear-gradient-462);}.cls-475{fill:url(#linear-gradient-463);}.cls-476{fill:url(#linear-gradient-464);}.cls-477{fill:url(#linear-gradient-465);}.cls-478{fill:url(#linear-gradient-466);}.cls-479{fill:url(#linear-gradient-467);}.cls-480{fill:url(#linear-gradient-468);}.cls-481{fill:url(#linear-gradient-469);}.cls-482{fill:url(#linear-gradient-470);}.cls-483{fill:url(#linear-gradient-471);}.cls-484{fill:url(#linear-gradient-472);}.cls-485{fill:url(#linear-gradient-473);}.cls-486{fill:url(#linear-gradient-474);}.cls-487{fill:url(#linear-gradient-475);}.cls-488{fill:url(#linear-gradient-476);}.cls-489{fill:url(#linear-gradient-477);}.cls-490{fill:url(#linear-gradient-478);}.cls-491{fill:url(#linear-gradient-479);}.cls-492{fill:url(#linear-gradient-480);}.cls-493{fill:url(#linear-gradient-481);}.cls-494{fill:url(#linear-gradient-482);}.cls-495{fill:url(#linear-gradient-483);}.cls-496{fill:url(#linear-gradient-484);}.cls-497{fill:url(#linear-gradient-485);}.cls-498{fill:url(#linear-gradient-486);}.cls-499{fill:url(#linear-gradient-487);}.cls-500{fill:url(#linear-gradient-488);}.cls-501{fill:url(#linear-gradient-489);}.cls-502{fill:url(#linear-gradient-490);}.cls-503{fill:url(#linear-gradient-491);}.cls-504{fill:url(#linear-gradient-492);}.cls-505{fill:url(#linear-gradient-493);}.cls-506{fill:url(#linear-gradient-494);}.cls-507{fill:url(#linear-gradient-495);}.cls-508{fill:url(#linear-gradient-496);}.cls-509{fill:url(#linear-gradient-497);}.cls-510{fill:url(#linear-gradient-498);}.cls-511{fill:url(#linear-gradient-499);}.cls-512{fill:url(#linear-gradient-500);}.cls-513{fill:url(#linear-gradient-501);}.cls-514{fill:url(#linear-gradient-502);}.cls-515{fill:url(#linear-gradient-503);}.cls-516{fill:url(#linear-gradient-504);}.cls-517{fill:url(#linear-gradient-505);}.cls-518{fill:url(#linear-gradient-506);}.cls-519{fill:url(#linear-gradient-507);}.cls-520{fill:url(#linear-gradient-508);}.cls-521{fill:url(#linear-gradient-509);}.cls-522{fill:url(#linear-gradient-510);}.cls-523{fill:url(#linear-gradient-511);}.cls-524{fill:url(#linear-gradient-512);}.cls-525{fill:url(#linear-gradient-513);}.cls-526{fill:url(#linear-gradient-514);}.cls-527{fill:url(#linear-gradient-515);}.cls-528{fill:url(#linear-gradient-516);}.cls-529{fill:url(#linear-gradient-517);}.cls-530{fill:url(#linear-gradient-518);}.cls-531{fill:url(#linear-gradient-519);}.cls-532{fill:url(#linear-gradient-520);}.cls-533{fill:url(#linear-gradient-521);}.cls-534{fill:url(#linear-gradient-522);}.cls-535{fill:url(#linear-gradient-523);}.cls-536{fill:url(#linear-gradient-524);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 71.15,
    y1: 70.95,
    x2: 113.65,
    y2: 86.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fec61b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0151b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 92.5,
    y1: 37.46,
    x2: 104.15,
    y2: 70.38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#67686b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d3d5d6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 322.46,
    y1: 213.55,
    x2: 324.18,
    y2: 216.76,
    gradientTransform: "translate(-179.92 -197.16) rotate(12.02)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ee492f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c0151b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 13.39,
    y1: 63.49,
    x2: 15.12,
    y2: 66.74,
    gradientTransform: "matrix(1, -0.05, 0.05, 1, 78.2, 16.2)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -267.68,
    y1: -189.28,
    x2: -265.9,
    y2: -185.96,
    gradientTransform: "translate(414.29 167.37) rotate(-19.49)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -338.06,
    y1: -285.44,
    x2: -336.27,
    y2: -282.08,
    gradientTransform: "translate(528.67 194.81) rotate(-24.71)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 670.99,
    y1: 277.53,
    x2: 672.72,
    y2: 280.77,
    gradientTransform: "translate(-379.39 -478.68) rotate(27.54)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 1060.11,
    y1: 235.77,
    x2: 1061.88,
    y2: 239.08,
    gradientTransform: "matrix(0.71, 0.7, -0.7, 0.71, -503.97, -836.82)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 124.53,
    y1: 23.46,
    x2: 82.28,
    y2: 30.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 143.26,
    y1: 29.08,
    x2: 60.65,
    y2: 41.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 92.9,
    y1: 27.22,
    x2: 65.69,
    y2: 31.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 130.93,
    y1: 19.29,
    x2: 86.87,
    y2: 25.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 70.82,
    y1: 83.91,
    x2: 95.32,
    y2: 83.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 102.11,
    y1: 80.87,
    x2: 119.56,
    y2: 116.11,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "97.36 87.25 112.66 75.77 127.11 112.5 105.86 115.12 97.36 87.25"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 132.14,
    y1: 125.3,
    x2: 76.26,
    y2: 85.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 132.46,
    y1: 124.82,
    x2: 76.61,
    y2: 85.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 132.59,
    y1: 124.67,
    x2: 76.68,
    y2: 85.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 132.46,
    y1: 124.83,
    x2: 76.59,
    y2: 85.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 132.13,
    y1: 125.31,
    x2: 76.25,
    y2: 85.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 131.6,
    y1: 126.05,
    x2: 75.73,
    y2: 86.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 130.94,
    y1: 127,
    x2: 75.04,
    y2: 87.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 130.19,
    y1: 128.06,
    x2: 74.3,
    y2: 88.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 129.42,
    y1: 129.14,
    x2: 73.55,
    y2: 89.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 128.71,
    y1: 130.15,
    x2: 72.84,
    y2: 90.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 128.11,
    y1: 131.01,
    x2: 72.24,
    y2: 91.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 127.68,
    y1: 131.62,
    x2: 71.81,
    y2: 92.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 127.45,
    y1: 131.93,
    x2: 71.59,
    y2: 92.57,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 127.45,
    y1: 131.93,
    x2: 71.59,
    y2: 92.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 127.68,
    y1: 131.6,
    x2: 71.83,
    y2: 92.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 128.13,
    y1: 130.99,
    x2: 72.24,
    y2: 91.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 128.72,
    y1: 130.13,
    x2: 72.86,
    y2: 90.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 129.44,
    y1: 129.12,
    x2: 73.56,
    y2: 89.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 130.2,
    y1: 128.03,
    x2: 74.33,
    y2: 88.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 130.95,
    y1: 126.97,
    x2: 75.08,
    y2: 87.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 131.62,
    y1: 126.03,
    x2: 75.74,
    y2: 86.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 138.58,
    y1: 116.14,
    x2: 82.71,
    y2: 76.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 138.91,
    y1: 115.67,
    x2: 83.05,
    y2: 76.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 139.01,
    y1: 115.5,
    x2: 83.19,
    y2: 76.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 138.91,
    y1: 115.68,
    x2: 83.05,
    y2: 76.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 138.57,
    y1: 116.15,
    x2: 82.73,
    y2: 76.8,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 138.05,
    y1: 116.89,
    x2: 82.19,
    y2: 77.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 137.39,
    y1: 117.84,
    x2: 81.51,
    y2: 78.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 136.64,
    y1: 118.9,
    x2: 80.76,
    y2: 79.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 135.88,
    y1: 119.99,
    x2: 80,
    y2: 80.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 135.16,
    y1: 121,
    x2: 79.29,
    y2: 81.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 134.56,
    y1: 121.85,
    x2: 78.69,
    y2: 82.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 134.14,
    y1: 122.47,
    x2: 78.24,
    y2: 83.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 133.91,
    y1: 122.79,
    x2: 78.02,
    y2: 83.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 133.92,
    y1: 122.79,
    x2: 78.01,
    y2: 83.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 134.15,
    y1: 122.47,
    x2: 78.23,
    y2: 83.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 134.57,
    y1: 121.83,
    x2: 78.7,
    y2: 82.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 135.18,
    y1: 120.99,
    x2: 79.29,
    y2: 81.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 135.89,
    y1: 119.96,
    x2: 80.02,
    y2: 80.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 136.66,
    y1: 118.88,
    x2: 80.78,
    y2: 79.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 137.41,
    y1: 117.82,
    x2: 81.52,
    y2: 78.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 138.06,
    y1: 116.88,
    x2: 82.2,
    y2: 77.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 134.65,
    y1: 121.71,
    x2: 78.81,
    y2: 82.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 134.99,
    y1: 121.24,
    x2: 79.1,
    y2: 81.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 135.11,
    y1: 121.09,
    x2: 79.21,
    y2: 81.69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-60",
    x1: 134.99,
    y1: 121.25,
    x2: 79.12,
    y2: 81.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-61",
    x1: 134.66,
    y1: 121.72,
    x2: 78.76,
    y2: 82.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-62",
    x1: 134.13,
    y1: 122.46,
    x2: 78.27,
    y2: 83.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-63",
    x1: 133.46,
    y1: 123.41,
    x2: 77.6,
    y2: 84.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-64",
    x1: 132.72,
    y1: 124.47,
    x2: 76.83,
    y2: 85.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-65",
    x1: 131.95,
    y1: 125.56,
    x2: 76.07,
    y2: 86.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-66",
    x1: 131.23,
    y1: 126.57,
    x2: 75.36,
    y2: 87.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-67",
    x1: 130.64,
    y1: 127.42,
    x2: 74.76,
    y2: 88.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-68",
    x1: 130.21,
    y1: 128.04,
    x2: 74.31,
    y2: 88.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-69",
    x1: 129.99,
    y1: 128.35,
    x2: 74.08,
    y2: 88.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-70",
    x1: 129.98,
    y1: 128.34,
    x2: 74.13,
    y2: 88.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-71",
    x1: 130.21,
    y1: 128.02,
    x2: 74.37,
    y2: 88.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-72",
    x1: 130.65,
    y1: 127.4,
    x2: 74.78,
    y2: 88.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-73",
    x1: 131.25,
    y1: 126.55,
    x2: 75.38,
    y2: 87.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-74",
    x1: 131.97,
    y1: 125.54,
    x2: 76.08,
    y2: 86.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-75",
    x1: 132.73,
    y1: 124.45,
    x2: 76.86,
    y2: 85.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-76",
    x1: 133.48,
    y1: 123.39,
    x2: 77.59,
    y2: 84,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-77",
    x1: 134.15,
    y1: 122.45,
    x2: 78.26,
    y2: 83.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-78",
    x1: 128.2,
    y1: 130.88,
    x2: 72.32,
    y2: 91.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-79",
    x1: 128.53,
    y1: 130.41,
    x2: 72.68,
    y2: 91.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-80",
    x1: 128.64,
    y1: 130.25,
    x2: 72.78,
    y2: 90.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-81",
    x1: 128.53,
    y1: 130.41,
    x2: 72.66,
    y2: 91.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-82",
    x1: 128.19,
    y1: 130.89,
    x2: 72.35,
    y2: 91.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-83",
    x1: 127.67,
    y1: 131.63,
    x2: 71.81,
    y2: 92.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-84",
    x1: 127.01,
    y1: 132.58,
    x2: 71.13,
    y2: 93.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-85",
    x1: 126.26,
    y1: 133.64,
    x2: 70.38,
    y2: 94.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-86",
    x1: 125.49,
    y1: 134.72,
    x2: 69.63,
    y2: 95.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-87",
    x1: 124.78,
    y1: 135.74,
    x2: 68.89,
    y2: 96.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-88",
    x1: 124.18,
    y1: 136.59,
    x2: 68.31,
    y2: 97.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-89",
    x1: 123.75,
    y1: 137.2,
    x2: 67.85,
    y2: 97.81,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-90",
    x1: 123.53,
    y1: 137.52,
    x2: 67.64,
    y2: 98.13,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-91",
    x1: 123.52,
    y1: 137.51,
    x2: 67.66,
    y2: 98.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-92",
    x1: 123.75,
    y1: 137.18,
    x2: 67.9,
    y2: 97.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-93",
    x1: 124.19,
    y1: 136.57,
    x2: 68.32,
    y2: 97.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-94",
    x1: 124.79,
    y1: 135.72,
    x2: 68.91,
    y2: 96.34,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-95",
    x1: 125.5,
    y1: 134.7,
    x2: 69.64,
    y2: 95.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-96",
    x1: 126.27,
    y1: 133.62,
    x2: 70.4,
    y2: 94.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-97",
    x1: 127.02,
    y1: 132.55,
    x2: 71.16,
    y2: 93.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-98",
    x1: 127.68,
    y1: 131.61,
    x2: 71.81,
    y2: 92.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-99",
    x1: 136.14,
    y1: 119.58,
    x2: 80.3,
    y2: 80.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-100",
    x1: 136.5,
    y1: 119.13,
    x2: 80.6,
    y2: 79.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-101",
    x1: 136.6,
    y1: 118.96,
    x2: 80.73,
    y2: 79.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-102",
    x1: 136.5,
    y1: 119.13,
    x2: 80.59,
    y2: 79.73,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-103",
    x1: 136.15,
    y1: 119.6,
    x2: 80.28,
    y2: 80.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-104",
    x1: 135.63,
    y1: 120.34,
    x2: 79.75,
    y2: 80.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-105",
    x1: 134.96,
    y1: 121.29,
    x2: 79.08,
    y2: 81.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-106",
    x1: 134.21,
    y1: 122.35,
    x2: 78.34,
    y2: 82.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-107",
    x1: 133.45,
    y1: 123.43,
    x2: 77.57,
    y2: 84.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-108",
    x1: 132.73,
    y1: 124.45,
    x2: 76.86,
    y2: 85.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-109",
    x1: 132.14,
    y1: 125.3,
    x2: 76.25,
    y2: 85.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-110",
    x1: 131.7,
    y1: 125.9,
    x2: 75.84,
    y2: 86.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-111",
    x1: 131.47,
    y1: 126.22,
    x2: 75.62,
    y2: 86.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-112",
    x1: 131.48,
    y1: 126.22,
    x2: 75.61,
    y2: 86.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-113",
    x1: 131.71,
    y1: 125.9,
    x2: 75.83,
    y2: 86.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-114",
    x1: 132.15,
    y1: 125.28,
    x2: 76.27,
    y2: 85.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-115",
    x1: 132.75,
    y1: 124.43,
    x2: 76.87,
    y2: 85.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-116",
    x1: 133.46,
    y1: 123.41,
    x2: 77.59,
    y2: 84.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-117",
    x1: 134.23,
    y1: 122.33,
    x2: 78.35,
    y2: 82.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-118",
    x1: 134.97,
    y1: 121.26,
    x2: 79.1,
    y2: 81.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-119",
    x1: 135.64,
    y1: 120.32,
    x2: 79.77,
    y2: 80.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-120",
    x1: 142.93,
    y1: 109.98,
    x2: 87.05,
    y2: 70.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-121",
    x1: 143.27,
    y1: 109.51,
    x2: 87.38,
    y2: 70.12,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-122",
    x1: 143.39,
    y1: 109.36,
    x2: 87.48,
    y2: 69.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-123",
    x1: 143.25,
    y1: 109.5,
    x2: 87.4,
    y2: 70.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-124",
    x1: 142.92,
    y1: 109.98,
    x2: 87.05,
    y2: 70.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-125",
    x1: 142.39,
    y1: 110.72,
    x2: 86.54,
    y2: 71.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-126",
    x1: 141.74,
    y1: 111.67,
    x2: 85.86,
    y2: 72.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-127",
    x1: 140.99,
    y1: 112.74,
    x2: 85.11,
    y2: 73.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-128",
    x1: 140.22,
    y1: 113.82,
    x2: 84.34,
    y2: 74.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-129",
    x1: 139.51,
    y1: 114.83,
    x2: 83.63,
    y2: 75.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-130",
    x1: 138.91,
    y1: 115.68,
    x2: 83.03,
    y2: 76.31,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-131",
    x1: 138.47,
    y1: 116.29,
    x2: 82.61,
    y2: 76.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-132",
    x1: 138.26,
    y1: 116.62,
    x2: 82.37,
    y2: 77.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-133",
    x1: 138.23,
    y1: 116.59,
    x2: 82.41,
    y2: 77.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-134",
    x1: 138.48,
    y1: 116.28,
    x2: 82.61,
    y2: 76.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-135",
    x1: 138.91,
    y1: 115.67,
    x2: 83.05,
    y2: 76.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-136",
    x1: 139.52,
    y1: 114.82,
    x2: 83.64,
    y2: 75.44,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-137",
    x1: 140.24,
    y1: 113.8,
    x2: 84.36,
    y2: 74.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-138",
    x1: 141.01,
    y1: 112.72,
    x2: 85.12,
    y2: 73.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-139",
    x1: 141.75,
    y1: 111.65,
    x2: 85.88,
    y2: 72.28,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-140",
    x1: 142.42,
    y1: 110.71,
    x2: 86.53,
    y2: 71.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-141",
    x1: 144.12,
    y1: 108.3,
    x2: 88.24,
    y2: 68.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-142",
    x1: 144.43,
    y1: 107.81,
    x2: 88.58,
    y2: 68.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-143",
    x1: 144.56,
    y1: 107.67,
    x2: 88.68,
    y2: 68.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-144",
    x1: 144.47,
    y1: 107.85,
    x2: 88.55,
    y2: 68.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-145",
    x1: 144.1,
    y1: 108.31,
    x2: 88.23,
    y2: 68.93,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-146",
    x1: 143.58,
    y1: 109.05,
    x2: 87.71,
    y2: 69.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-147",
    x1: 142.92,
    y1: 110,
    x2: 87.04,
    y2: 70.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-148",
    x1: 142.18,
    y1: 111.07,
    x2: 86.29,
    y2: 71.68,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-149",
    x1: 141.4,
    y1: 112.15,
    x2: 85.53,
    y2: 72.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-150",
    x1: 140.68,
    y1: 113.15,
    x2: 84.82,
    y2: 73.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-151",
    x1: 140.09,
    y1: 114.01,
    x2: 84.22,
    y2: 74.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-152",
    x1: 139.64,
    y1: 114.6,
    x2: 83.79,
    y2: 75.25,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-153",
    x1: 139.45,
    y1: 114.95,
    x2: 83.55,
    y2: 75.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-154",
    x1: 139.44,
    y1: 114.94,
    x2: 83.56,
    y2: 75.56,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-155",
    x1: 139.64,
    y1: 114.59,
    x2: 83.8,
    y2: 75.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-156",
    x1: 140.09,
    y1: 113.98,
    x2: 84.23,
    y2: 74.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-157",
    x1: 140.69,
    y1: 113.13,
    x2: 84.83,
    y2: 73.76,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-158",
    x1: 141.42,
    y1: 112.12,
    x2: 85.54,
    y2: 72.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-159",
    x1: 142.19,
    y1: 111.04,
    x2: 86.31,
    y2: 71.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-160",
    x1: 142.93,
    y1: 109.97,
    x2: 87.06,
    y2: 70.6,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-161",
    x1: 143.59,
    y1: 109.03,
    x2: 87.72,
    y2: 69.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-162",
    x1: 150.57,
    y1: 99.15,
    x2: 94.69,
    y2: 59.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-163",
    x1: 150.9,
    y1: 98.68,
    x2: 95.02,
    y2: 59.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-164",
    x1: 150.97,
    y1: 98.49,
    x2: 95.15,
    y2: 59.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-165",
    x1: 150.91,
    y1: 98.69,
    x2: 95.01,
    y2: 59.3,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-166",
    x1: 150.55,
    y1: 99.15,
    x2: 94.68,
    y2: 59.78,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-167",
    x1: 150.04,
    y1: 99.9,
    x2: 94.16,
    y2: 60.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-168",
    x1: 149.37,
    y1: 100.85,
    x2: 93.49,
    y2: 61.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-169",
    x1: 148.61,
    y1: 101.9,
    x2: 92.75,
    y2: 62.53,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-170",
    x1: 147.85,
    y1: 102.99,
    x2: 91.98,
    y2: 63.62,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-171",
    x1: 147.15,
    y1: 104.01,
    x2: 91.26,
    y2: 64.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-172",
    x1: 146.55,
    y1: 104.86,
    x2: 90.66,
    y2: 65.48,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-173",
    x1: 146.12,
    y1: 105.47,
    x2: 90.23,
    y2: 66.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-174",
    x1: 145.89,
    y1: 105.78,
    x2: 90.01,
    y2: 66.41,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-175",
    x1: 145.9,
    y1: 105.79,
    x2: 90.01,
    y2: 66.4,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-176",
    x1: 146.15,
    y1: 105.48,
    x2: 90.23,
    y2: 66.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-177",
    x1: 146.55,
    y1: 104.84,
    x2: 90.68,
    y2: 65.46,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-178",
    x1: 147.15,
    y1: 103.98,
    x2: 91.28,
    y2: 64.61,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-179",
    x1: 147.87,
    y1: 102.97,
    x2: 92,
    y2: 63.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-180",
    x1: 148.63,
    y1: 101.88,
    x2: 92.76,
    y2: 62.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-181",
    x1: 149.38,
    y1: 100.82,
    x2: 93.51,
    y2: 61.45,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-182",
    x1: 150.04,
    y1: 99.88,
    x2: 94.17,
    y2: 60.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-183",
    x1: 146.62,
    y1: 104.7,
    x2: 90.77,
    y2: 65.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-184",
    x1: 146.96,
    y1: 104.23,
    x2: 91.1,
    y2: 64.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-185",
    x1: 147.1,
    y1: 104.09,
    x2: 91.2,
    y2: 64.7,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-186",
    x1: 146.95,
    y1: 104.24,
    x2: 91.1,
    y2: 64.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-187",
    x1: 146.63,
    y1: 104.72,
    x2: 90.76,
    y2: 65.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-188",
    x1: 146.11,
    y1: 105.46,
    x2: 90.24,
    y2: 66.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-189",
    x1: 145.45,
    y1: 106.42,
    x2: 89.56,
    y2: 67.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-190",
    x1: 144.7,
    y1: 107.48,
    x2: 88.81,
    y2: 68.09,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-191",
    x1: 143.93,
    y1: 108.56,
    x2: 88.05,
    y2: 69.19,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-192",
    x1: 143.21,
    y1: 109.57,
    x2: 87.34,
    y2: 70.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-193",
    x1: 142.62,
    y1: 110.42,
    x2: 86.74,
    y2: 71.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-194",
    x1: 142.18,
    y1: 111.03,
    x2: 86.31,
    y2: 71.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-195",
    x1: 141.95,
    y1: 111.35,
    x2: 86.09,
    y2: 71.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-196",
    x1: 141.95,
    y1: 111.34,
    x2: 86.1,
    y2: 71.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-197",
    x1: 142.21,
    y1: 111.03,
    x2: 86.31,
    y2: 71.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-198",
    x1: 142.63,
    y1: 110.41,
    x2: 86.75,
    y2: 71.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-199",
    x1: 143.22,
    y1: 109.55,
    x2: 87.36,
    y2: 70.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-200",
    x1: 143.94,
    y1: 108.53,
    x2: 88.07,
    y2: 69.16,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-201",
    x1: 144.71,
    y1: 107.45,
    x2: 88.84,
    y2: 68.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-202",
    x1: 145.47,
    y1: 106.4,
    x2: 89.58,
    y2: 67.01,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-203",
    x1: 146.12,
    y1: 105.45,
    x2: 90.25,
    y2: 66.07,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-204",
    x1: 140.18,
    y1: 113.88,
    x2: 84.3,
    y2: 74.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-205",
    x1: 140.49,
    y1: 113.4,
    x2: 84.65,
    y2: 74.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-206",
    x1: 140.61,
    y1: 113.24,
    x2: 84.75,
    y2: 73.88,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-207",
    x1: 140.49,
    y1: 113.4,
    x2: 84.64,
    y2: 74.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-208",
    x1: 140.17,
    y1: 113.89,
    x2: 84.3,
    y2: 74.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-209",
    x1: 139.64,
    y1: 114.63,
    x2: 83.78,
    y2: 75.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-210",
    x1: 138.98,
    y1: 115.57,
    x2: 83.11,
    y2: 76.21,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-211",
    x1: 138.24,
    y1: 116.64,
    x2: 82.36,
    y2: 77.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-212",
    x1: 137.46,
    y1: 117.72,
    x2: 81.6,
    y2: 78.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-213",
    x1: 136.76,
    y1: 118.75,
    x2: 80.87,
    y2: 79.36,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-214",
    x1: 136.15,
    y1: 119.59,
    x2: 80.29,
    y2: 80.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-215",
    x1: 135.72,
    y1: 120.2,
    x2: 79.85,
    y2: 80.83,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-216",
    x1: 135.51,
    y1: 120.53,
    x2: 79.62,
    y2: 81.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-217",
    x1: 135.5,
    y1: 120.51,
    x2: 79.64,
    y2: 81.14,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-218",
    x1: 135.72,
    y1: 120.18,
    x2: 79.87,
    y2: 80.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-219",
    x1: 136.16,
    y1: 119.57,
    x2: 80.29,
    y2: 80.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-220",
    x1: 136.76,
    y1: 118.72,
    x2: 80.9,
    y2: 79.35,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-221",
    x1: 137.48,
    y1: 117.7,
    x2: 81.61,
    y2: 78.33,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-222",
    x1: 138.25,
    y1: 116.62,
    x2: 82.38,
    y2: 77.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-223",
    x1: 139,
    y1: 115.56,
    x2: 83.12,
    y2: 76.18,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-224",
    x1: 139.66,
    y1: 114.61,
    x2: 83.79,
    y2: 75.24,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-225",
    x1: 148.12,
    y1: 102.58,
    x2: 92.26,
    y2: 63.22,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-226",
    x1: 148.51,
    y1: 102.15,
    x2: 92.59,
    y2: 62.74,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-227",
    x1: 148.57,
    y1: 101.95,
    x2: 92.71,
    y2: 62.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-228",
    x1: 148.49,
    y1: 102.15,
    x2: 92.58,
    y2: 62.75,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-229",
    x1: 148.11,
    y1: 102.59,
    x2: 92.26,
    y2: 63.23,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-230",
    x1: 147.6,
    y1: 103.34,
    x2: 91.73,
    y2: 63.97,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-231",
    x1: 146.94,
    y1: 104.29,
    x2: 91.06,
    y2: 64.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-232",
    x1: 146.18,
    y1: 105.34,
    x2: 90.32,
    y2: 65.98,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-233",
    x1: 145.41,
    y1: 106.43,
    x2: 89.55,
    y2: 67.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-234",
    x1: 144.7,
    y1: 107.44,
    x2: 88.84,
    y2: 68.08,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-235",
    x1: 144.13,
    y1: 108.31,
    x2: 88.23,
    y2: 68.92,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-236",
    x1: 143.68,
    y1: 108.91,
    x2: 87.81,
    y2: 69.54,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-237",
    x1: 143.44,
    y1: 109.21,
    x2: 87.59,
    y2: 69.86,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-238",
    x1: 143.43,
    y1: 109.21,
    x2: 87.59,
    y2: 69.85,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-239",
    x1: 143.69,
    y1: 108.9,
    x2: 87.81,
    y2: 69.52,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-240",
    x1: 144.11,
    y1: 108.27,
    x2: 88.25,
    y2: 68.91,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-241",
    x1: 144.75,
    y1: 107.45,
    x2: 88.85,
    y2: 68.05,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-242",
    x1: 145.44,
    y1: 106.41,
    x2: 89.57,
    y2: 67.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-243",
    x1: 146.21,
    y1: 105.33,
    x2: 90.33,
    y2: 65.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-244",
    x1: 146.95,
    y1: 104.26,
    x2: 91.08,
    y2: 64.89,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-245",
    x1: 147.62,
    y1: 103.33,
    x2: 91.74,
    y2: 63.95,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-246",
    x1: 90.82,
    y1: 102.2,
    x2: 103.99,
    y2: 102.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-247",
    x1: 54.53,
    y1: 350.8,
    x2: 58.16,
    y2: 350.8,
    gradientTransform: "matrix(1, -0.32, 0, 1, 0, -280.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-248",
    x1: 54.53,
    y1: 356.8,
    x2: 58.16,
    y2: 356.8,
    gradientTransform: "matrix(1, -0.32, 0, 1, 0, -280.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-249",
    x1: 54.53,
    y1: 362.8,
    x2: 58.16,
    y2: 362.8,
    gradientTransform: "matrix(1, -0.32, 0, 1, 0, -280.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-250",
    x1: 54.53,
    y1: 368.81,
    x2: 58.16,
    y2: 368.81,
    gradientTransform: "matrix(1, -0.32, 0, 1, 0, -280.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-251",
    x1: 54.53,
    y1: 374.81,
    x2: 58.16,
    y2: 374.81,
    gradientTransform: "matrix(1, -0.32, 0, 1, 0, -280.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-252",
    x1: 54.53,
    y1: 380.82,
    x2: 58.16,
    y2: 380.82,
    gradientTransform: "matrix(1, -0.32, 0, 1, 0, -280.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-253",
    x1: 54.53,
    y1: 386.82,
    x2: 58.16,
    y2: 386.82,
    gradientTransform: "matrix(1, -0.32, 0, 1, 0, -280.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-254",
    x1: 54.53,
    y1: 392.82,
    x2: 58.16,
    y2: 392.82,
    gradientTransform: "matrix(1, -0.32, 0, 1, 0, -280.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-255",
    x1: 54.53,
    y1: 398.83,
    x2: 58.16,
    y2: 398.83,
    gradientTransform: "matrix(1, -0.32, 0, 1, 0, -280.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-256",
    x1: 54.53,
    y1: 404.83,
    x2: 58.16,
    y2: 404.83,
    gradientTransform: "matrix(1, -0.32, 0, 1, 0, -280.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-257",
    x1: 54.53,
    y1: 410.83,
    x2: 58.16,
    y2: 410.83,
    gradientTransform: "matrix(1, -0.32, 0, 1, 0, -280.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-258",
    x1: 54.53,
    y1: 416.84,
    x2: 58.16,
    y2: 416.84,
    gradientTransform: "matrix(1, -0.32, 0, 1, 0, -280.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-259",
    x1: -1831.89,
    y1: 833.83,
    x2: -1826.72,
    y2: 833.83,
    gradientTransform: "translate(-1773.05 893.67) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d8d9da"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#afb1b4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-260",
    x1: 37.68,
    y1: 59.59,
    x2: 55.26,
    y2: 59.59,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-259"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-261",
    x1: 37.69,
    y1: 49.79,
    x2: 45.26,
    y2: 49.79,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-259"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-262",
    x1: 47.84,
    y1: 59.84,
    x2: 40.18,
    y2: 59.84,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    xlinkHref: "#linear-gradient-259"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-263",
    x1: -1606.04,
    y1: 776.71,
    x2: -1563.54,
    y2: 792.71,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-264",
    x1: -1584.7,
    y1: 743.22,
    x2: -1573.04,
    y2: 776.14,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-265",
    x1: -1170.89,
    y1: 1253.14,
    x2: -1169.18,
    y2: 1256.36,
    gradientTransform: "translate(-1331.16 1137.1) rotate(-167.98)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-266",
    x1: -1698.58,
    y1: 680.24,
    x2: -1696.85,
    y2: 683.48,
    gradientTransform: "matrix(-1, 0.05, -0.05, -1, -1589.27, 923.74)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-267",
    x1: -2084.26,
    y1: -83.47,
    x2: -2082.49,
    y2: -80.15,
    gradientTransform: "translate(-1925.36 772.58) rotate(160.51)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-268",
    x1: -2156.7,
    y1: -345.56,
    x2: -2154.91,
    y2: -342.2,
    gradientTransform: "translate(-2039.75 745.13) rotate(155.29)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-269",
    x1: -489.95,
    y1: 1678.76,
    x2: -488.22,
    y2: 1681.99,
    gradientTransform: "translate(-1131.69 1418.63) rotate(-152.46)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-270",
    x1: 362.57,
    y1: 1916.51,
    x2: 364.34,
    y2: 1919.82,
    gradientTransform: "matrix(-0.71, -0.7, 0.7, -0.71, -1007.11, 1776.77)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-271",
    x1: -1552.66,
    y1: 729.22,
    x2: -1594.91,
    y2: 736.72,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-272",
    x1: -1533.94,
    y1: 734.84,
    x2: -1616.54,
    y2: 746.98,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-273",
    x1: -1584.29,
    y1: 732.98,
    x2: -1611.51,
    y2: 736.98,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-274",
    x1: -1546.26,
    y1: 725.05,
    x2: -1590.32,
    y2: 731.52,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-275",
    x1: -1606.37,
    y1: 789.67,
    x2: -1581.87,
    y2: 789.67,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-276",
    x1: -1575.09,
    y1: 786.63,
    x2: -1557.64,
    y2: 821.87,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "68.75 146.94 53.46 158.42 39 121.69 60.25 119.07 68.75 146.94"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-277",
    x1: -1545.06,
    y1: 831.06,
    x2: -1600.94,
    y2: 791.68,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-278",
    x1: -1544.74,
    y1: 830.58,
    x2: -1600.59,
    y2: 791.22,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-279",
    x1: -1544.6,
    y1: 830.43,
    x2: -1600.51,
    y2: 791.04,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-280",
    x1: -1544.73,
    y1: 830.59,
    x2: -1600.6,
    y2: 791.22,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-281",
    x1: -1545.07,
    y1: 831.06,
    x2: -1600.92,
    y2: 791.71,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-282",
    x1: -1545.59,
    y1: 831.81,
    x2: -1601.47,
    y2: 792.43,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-283",
    x1: -1546.25,
    y1: 832.76,
    x2: -1602.15,
    y2: 793.37,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-284",
    x1: -1547,
    y1: 833.82,
    x2: -1602.89,
    y2: 794.43,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-285",
    x1: -1547.77,
    y1: 834.91,
    x2: -1603.66,
    y2: 795.52,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-286",
    x1: -1548.48,
    y1: 835.92,
    x2: -1604.37,
    y2: 796.54,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-287",
    x1: -1549.08,
    y1: 836.77,
    x2: -1604.95,
    y2: 797.39,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-288",
    x1: -1549.51,
    y1: 837.38,
    x2: -1605.4,
    y2: 797.99,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-289",
    x1: -1549.74,
    y1: 837.69,
    x2: -1605.6,
    y2: 798.33,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-290",
    x1: -1549.73,
    y1: 837.7,
    x2: -1605.62,
    y2: 798.31,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-291",
    x1: -1549.5,
    y1: 837.37,
    x2: -1605.38,
    y2: 797.99,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-292",
    x1: -1549.07,
    y1: 836.75,
    x2: -1604.96,
    y2: 797.37,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-293",
    x1: -1548.47,
    y1: 835.89,
    x2: -1604.34,
    y2: 796.53,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-294",
    x1: -1547.75,
    y1: 834.88,
    x2: -1603.63,
    y2: 795.5,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-295",
    x1: -1546.99,
    y1: 833.79,
    x2: -1602.86,
    y2: 794.42,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-296",
    x1: -1546.23,
    y1: 832.74,
    x2: -1602.12,
    y2: 793.35,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-297",
    x1: -1545.58,
    y1: 831.79,
    x2: -1601.45,
    y2: 792.42,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-298",
    x1: -1538.61,
    y1: 821.9,
    x2: -1594.49,
    y2: 782.53,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-299",
    x1: -1538.28,
    y1: 821.43,
    x2: -1594.14,
    y2: 782.07,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-300",
    x1: -1538.17,
    y1: 821.27,
    x2: -1594.03,
    y2: 781.91,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-301",
    x1: -1538.29,
    y1: 821.43,
    x2: -1594.13,
    y2: 782.08,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-302",
    x1: -1538.62,
    y1: 821.91,
    x2: -1594.48,
    y2: 782.55,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-303",
    x1: -1539.14,
    y1: 822.65,
    x2: -1595,
    y2: 783.29,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-304",
    x1: -1539.81,
    y1: 823.6,
    x2: -1595.67,
    y2: 784.23,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-305",
    x1: -1540.55,
    y1: 824.66,
    x2: -1596.43,
    y2: 785.29,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-306",
    x1: -1541.32,
    y1: 825.75,
    x2: -1597.19,
    y2: 786.37,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-307",
    x1: -1542.03,
    y1: 826.76,
    x2: -1597.91,
    y2: 787.39,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-308",
    x1: -1542.63,
    y1: 827.61,
    x2: -1598.51,
    y2: 788.24,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-309",
    x1: -1543.07,
    y1: 828.22,
    x2: -1598.93,
    y2: 788.85,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-310",
    x1: -1543.28,
    y1: 828.55,
    x2: -1599.18,
    y2: 789.16,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-311",
    x1: -1543.26,
    y1: 828.55,
    x2: -1599.21,
    y2: 789.13,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-312",
    x1: -1543.05,
    y1: 828.22,
    x2: -1598.94,
    y2: 788.83,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-313",
    x1: -1542.63,
    y1: 827.59,
    x2: -1598.48,
    y2: 788.23,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-314",
    x1: -1542.01,
    y1: 826.75,
    x2: -1597.9,
    y2: 787.36,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-315",
    x1: -1541.31,
    y1: 825.72,
    x2: -1597.17,
    y2: 786.36,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-316",
    x1: -1540.54,
    y1: 824.64,
    x2: -1596.41,
    y2: 785.27,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-317",
    x1: -1539.79,
    y1: 823.58,
    x2: -1595.66,
    y2: 784.2,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-318",
    x1: -1539.13,
    y1: 822.64,
    x2: -1595,
    y2: 783.27,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-319",
    x1: -1542.54,
    y1: 827.47,
    x2: -1598.39,
    y2: 788.11,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-320",
    x1: -1542.21,
    y1: 827,
    x2: -1598.06,
    y2: 787.64,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-321",
    x1: -1542.08,
    y1: 826.84,
    x2: -1597.99,
    y2: 787.45,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-322",
    x1: -1542.21,
    y1: 827.01,
    x2: -1598.07,
    y2: 787.64,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-323",
    x1: -1542.54,
    y1: 827.48,
    x2: -1598.41,
    y2: 788.11,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-324",
    x1: -1543.07,
    y1: 828.22,
    x2: -1598.92,
    y2: 788.86,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-325",
    x1: -1543.73,
    y1: 829.17,
    x2: -1599.61,
    y2: 789.79,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-326",
    x1: -1544.48,
    y1: 830.23,
    x2: -1600.36,
    y2: 790.86,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-327",
    x1: -1545.24,
    y1: 831.32,
    x2: -1601.12,
    y2: 791.94,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-328",
    x1: -1545.96,
    y1: 832.33,
    x2: -1601.83,
    y2: 792.96,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-329",
    x1: -1546.56,
    y1: 833.18,
    x2: -1602.43,
    y2: 793.81,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-330",
    x1: -1546.98,
    y1: 833.79,
    x2: -1602.89,
    y2: 794.4,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-331",
    x1: -1547.21,
    y1: 834.11,
    x2: -1603.11,
    y2: 794.72,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-332",
    x1: -1547.22,
    y1: 834.1,
    x2: -1603.04,
    y2: 794.76,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-333",
    x1: -1546.99,
    y1: 833.78,
    x2: -1602.83,
    y2: 794.43,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-334",
    x1: -1546.55,
    y1: 833.16,
    x2: -1602.42,
    y2: 793.79,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-335",
    x1: -1545.95,
    y1: 832.31,
    x2: -1601.81,
    y2: 792.94,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-336",
    x1: -1545.22,
    y1: 831.3,
    x2: -1601.12,
    y2: 791.91,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-337",
    x1: -1544.47,
    y1: 830.21,
    x2: -1600.33,
    y2: 790.84,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-338",
    x1: -1543.71,
    y1: 829.15,
    x2: -1599.59,
    y2: 789.77,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-339",
    x1: -1543.05,
    y1: 828.21,
    x2: -1598.92,
    y2: 788.83,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-340",
    x1: -1548.99,
    y1: 836.64,
    x2: -1604.87,
    y2: 797.26,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-341",
    x1: -1548.67,
    y1: 836.17,
    x2: -1604.52,
    y2: 796.81,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-342",
    x1: -1548.55,
    y1: 836.01,
    x2: -1604.41,
    y2: 796.64,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-343",
    x1: -1548.67,
    y1: 836.17,
    x2: -1604.54,
    y2: 796.8,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-344",
    x1: -1549,
    y1: 836.65,
    x2: -1604.87,
    y2: 797.28,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-345",
    x1: -1549.53,
    y1: 837.39,
    x2: -1605.38,
    y2: 798.03,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-346",
    x1: -1550.19,
    y1: 838.34,
    x2: -1606.07,
    y2: 798.96,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-347",
    x1: -1550.94,
    y1: 839.4,
    x2: -1606.83,
    y2: 800.01,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-348",
    x1: -1551.7,
    y1: 840.49,
    x2: -1607.58,
    y2: 801.11,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-349",
    x1: -1552.42,
    y1: 841.5,
    x2: -1608.31,
    y2: 802.11,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-350",
    x1: -1553.02,
    y1: 842.35,
    x2: -1608.88,
    y2: 802.98,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-351",
    x1: -1553.45,
    y1: 842.96,
    x2: -1609.32,
    y2: 803.59,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-352",
    x1: -1553.68,
    y1: 843.27,
    x2: -1609.53,
    y2: 803.91,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-353",
    x1: -1553.66,
    y1: 843.28,
    x2: -1609.56,
    y2: 803.89,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-354",
    x1: -1553.44,
    y1: 842.95,
    x2: -1609.32,
    y2: 803.57,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-355",
    x1: -1553.01,
    y1: 842.33,
    x2: -1608.88,
    y2: 802.96,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-356",
    x1: -1552.4,
    y1: 841.48,
    x2: -1608.29,
    y2: 802.1,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-357",
    x1: -1551.69,
    y1: 840.46,
    x2: -1607.56,
    y2: 801.09,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-358",
    x1: -1550.92,
    y1: 839.38,
    x2: -1606.81,
    y2: 799.99,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-359",
    x1: -1550.17,
    y1: 838.31,
    x2: -1606.05,
    y2: 798.94,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-360",
    x1: -1549.51,
    y1: 837.38,
    x2: -1605.4,
    y2: 797.99,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-361",
    x1: -1541.05,
    y1: 825.34,
    x2: -1596.9,
    y2: 785.98,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-362",
    x1: -1540.69,
    y1: 824.89,
    x2: -1596.59,
    y2: 785.49,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-363",
    x1: -1540.58,
    y1: 824.73,
    x2: -1596.48,
    y2: 785.34,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-364",
    x1: -1540.69,
    y1: 824.9,
    x2: -1596.6,
    y2: 785.49,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-365",
    x1: -1541.05,
    y1: 825.36,
    x2: -1596.92,
    y2: 785.99,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-366",
    x1: -1541.56,
    y1: 826.11,
    x2: -1597.45,
    y2: 786.72,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-367",
    x1: -1542.24,
    y1: 827.04,
    x2: -1598.1,
    y2: 787.68,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-368",
    x1: -1542.98,
    y1: 828.11,
    x2: -1598.86,
    y2: 788.73,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-369",
    x1: -1543.75,
    y1: 829.19,
    x2: -1599.62,
    y2: 789.82,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-370",
    x1: -1544.46,
    y1: 830.21,
    x2: -1600.33,
    y2: 790.84,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-371",
    x1: -1545.05,
    y1: 831.06,
    x2: -1600.95,
    y2: 791.67,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-372",
    x1: -1545.51,
    y1: 831.65,
    x2: -1601.34,
    y2: 792.31,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-373",
    x1: -1545.73,
    y1: 831.98,
    x2: -1601.58,
    y2: 792.62,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-374",
    x1: -1545.7,
    y1: 831.99,
    x2: -1601.6,
    y2: 792.6,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-375",
    x1: -1545.5,
    y1: 831.65,
    x2: -1601.34,
    y2: 792.29,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-376",
    x1: -1545.04,
    y1: 831.05,
    x2: -1600.93,
    y2: 791.66,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-377",
    x1: -1544.44,
    y1: 830.19,
    x2: -1600.33,
    y2: 790.81,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-378",
    x1: -1543.75,
    y1: 829.16,
    x2: -1599.59,
    y2: 789.81,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-379",
    x1: -1542.97,
    y1: 828.09,
    x2: -1598.84,
    y2: 788.71,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-380",
    x1: -1542.23,
    y1: 827.02,
    x2: -1598.09,
    y2: 787.66,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-381",
    x1: -1541.56,
    y1: 826.08,
    x2: -1597.43,
    y2: 786.71,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-382",
    x1: -1534.26,
    y1: 815.74,
    x2: -1590.14,
    y2: 776.36,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-383",
    x1: -1533.92,
    y1: 815.27,
    x2: -1589.82,
    y2: 775.88,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-384",
    x1: -1533.79,
    y1: 815.13,
    x2: -1589.73,
    y2: 775.7,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-385",
    x1: -1533.94,
    y1: 815.27,
    x2: -1589.81,
    y2: 775.9,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-386",
    x1: -1534.27,
    y1: 815.74,
    x2: -1590.14,
    y2: 776.37,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-387",
    x1: -1534.78,
    y1: 816.49,
    x2: -1590.68,
    y2: 777.1,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-388",
    x1: -1535.46,
    y1: 817.43,
    x2: -1591.33,
    y2: 778.06,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-389",
    x1: -1536.21,
    y1: 818.5,
    x2: -1592.09,
    y2: 779.12,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-390",
    x1: -1536.97,
    y1: 819.58,
    x2: -1592.85,
    y2: 780.2,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-391",
    x1: -1537.69,
    y1: 820.59,
    x2: -1593.56,
    y2: 781.22,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-392",
    x1: -1538.29,
    y1: 821.44,
    x2: -1594.16,
    y2: 782.07,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-393",
    x1: -1538.73,
    y1: 822.04,
    x2: -1594.57,
    y2: 782.7,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-394",
    x1: -1538.93,
    y1: 822.38,
    x2: -1594.83,
    y2: 782.99,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-395",
    x1: -1538.96,
    y1: 822.35,
    x2: -1594.78,
    y2: 783.02,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-396",
    x1: -1538.73,
    y1: 822.03,
    x2: -1594.56,
    y2: 782.68,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-397",
    x1: -1538.28,
    y1: 821.43,
    x2: -1594.15,
    y2: 782.06,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-398",
    x1: -1537.67,
    y1: 820.58,
    x2: -1593.55,
    y2: 781.2,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-399",
    x1: -1536.96,
    y1: 819.56,
    x2: -1592.83,
    y2: 780.19,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-400",
    x1: -1536.18,
    y1: 818.48,
    x2: -1592.07,
    y2: 779.09,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-401",
    x1: -1535.45,
    y1: 817.4,
    x2: -1591.31,
    y2: 778.04,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-402",
    x1: -1534.77,
    y1: 816.47,
    x2: -1590.66,
    y2: 777.09,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-403",
    x1: -1533.08,
    y1: 814.06,
    x2: -1588.96,
    y2: 774.68,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-404",
    x1: -1532.77,
    y1: 813.57,
    x2: -1588.62,
    y2: 774.22,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-405",
    x1: -1532.67,
    y1: 813.4,
    x2: -1588.5,
    y2: 774.06,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-406",
    x1: -1532.73,
    y1: 813.61,
    x2: -1588.64,
    y2: 774.21,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-407",
    x1: -1533.11,
    y1: 814.05,
    x2: -1588.95,
    y2: 774.7,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-408",
    x1: -1533.61,
    y1: 814.81,
    x2: -1589.49,
    y2: 775.44,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-409",
    x1: -1534.26,
    y1: 815.77,
    x2: -1590.16,
    y2: 776.38,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-410",
    x1: -1535.02,
    y1: 816.83,
    x2: -1590.91,
    y2: 777.44,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-411",
    x1: -1535.79,
    y1: 817.91,
    x2: -1591.67,
    y2: 778.53,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-412",
    x1: -1536.51,
    y1: 818.91,
    x2: -1592.38,
    y2: 779.54,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-413",
    x1: -1537.11,
    y1: 819.77,
    x2: -1592.98,
    y2: 780.39,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-414",
    x1: -1537.55,
    y1: 820.37,
    x2: -1593.4,
    y2: 781.01,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-415",
    x1: -1537.74,
    y1: 820.71,
    x2: -1593.64,
    y2: 781.32,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-416",
    x1: -1537.71,
    y1: 820.73,
    x2: -1593.65,
    y2: 781.31,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-417",
    x1: -1537.52,
    y1: 820.37,
    x2: -1593.41,
    y2: 780.99,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-418",
    x1: -1537.1,
    y1: 819.75,
    x2: -1592.97,
    y2: 780.38,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-419",
    x1: -1536.5,
    y1: 818.89,
    x2: -1592.36,
    y2: 779.52,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-420",
    x1: -1535.78,
    y1: 817.88,
    x2: -1591.65,
    y2: 778.51,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-421",
    x1: -1535,
    y1: 816.8,
    x2: -1590.89,
    y2: 777.42,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-422",
    x1: -1534.25,
    y1: 815.74,
    x2: -1590.14,
    y2: 776.36,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-423",
    x1: -1533.6,
    y1: 814.79,
    x2: -1589.47,
    y2: 775.42,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-424",
    x1: -1526.63,
    y1: 804.91,
    x2: -1582.51,
    y2: 765.53,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-425",
    x1: -1526.31,
    y1: 804.43,
    x2: -1582.17,
    y2: 765.06,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-426",
    x1: -1526.22,
    y1: 804.25,
    x2: -1582.05,
    y2: 764.91,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-427",
    x1: -1526.3,
    y1: 804.44,
    x2: -1582.18,
    y2: 765.06,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-428",
    x1: -1526.64,
    y1: 804.91,
    x2: -1582.51,
    y2: 765.54,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-429",
    x1: -1527.16,
    y1: 805.66,
    x2: -1583.04,
    y2: 766.28,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-430",
    x1: -1527.84,
    y1: 806.59,
    x2: -1583.7,
    y2: 767.23,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-431",
    x1: -1528.57,
    y1: 807.67,
    x2: -1584.45,
    y2: 768.29,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-432",
    x1: -1529.34,
    y1: 808.75,
    x2: -1585.22,
    y2: 769.38,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-433",
    x1: -1530.04,
    y1: 809.77,
    x2: -1585.94,
    y2: 770.39,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-434",
    x1: -1530.66,
    y1: 810.61,
    x2: -1586.53,
    y2: 771.24,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-435",
    x1: -1531.09,
    y1: 811.22,
    x2: -1586.95,
    y2: 771.85,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-436",
    x1: -1531.29,
    y1: 811.56,
    x2: -1587.19,
    y2: 772.16,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-437",
    x1: -1531.29,
    y1: 811.55,
    x2: -1587.19,
    y2: 772.16,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-438",
    x1: -1531.06,
    y1: 811.23,
    x2: -1586.96,
    y2: 771.84,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-439",
    x1: -1530.64,
    y1: 810.6,
    x2: -1586.52,
    y2: 771.22,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-440",
    x1: -1530.03,
    y1: 809.75,
    x2: -1585.92,
    y2: 770.37,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-441",
    x1: -1529.32,
    y1: 808.73,
    x2: -1585.2,
    y2: 769.35,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-442",
    x1: -1528.56,
    y1: 807.64,
    x2: -1584.43,
    y2: 768.27,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-443",
    x1: -1527.82,
    y1: 806.57,
    x2: -1583.68,
    y2: 767.21,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-444",
    x1: -1527.14,
    y1: 805.64,
    x2: -1583.02,
    y2: 766.26,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-445",
    x1: -1530.57,
    y1: 810.46,
    x2: -1586.42,
    y2: 771.11,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-446",
    x1: -1530.24,
    y1: 809.99,
    x2: -1586.09,
    y2: 770.64,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-447",
    x1: -1530.1,
    y1: 809.85,
    x2: -1586,
    y2: 770.46,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-448",
    x1: -1530.23,
    y1: 810.01,
    x2: -1586.1,
    y2: 770.64,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-449",
    x1: -1530.58,
    y1: 810.47,
    x2: -1586.42,
    y2: 771.12,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-450",
    x1: -1531.08,
    y1: 811.23,
    x2: -1586.96,
    y2: 771.85,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-451",
    x1: -1531.75,
    y1: 812.17,
    x2: -1587.63,
    y2: 772.79,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-452",
    x1: -1532.5,
    y1: 813.24,
    x2: -1588.38,
    y2: 773.86,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-453",
    x1: -1533.27,
    y1: 814.32,
    x2: -1589.14,
    y2: 774.94,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-454",
    x1: -1533.98,
    y1: 815.33,
    x2: -1589.85,
    y2: 775.96,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-455",
    x1: -1534.58,
    y1: 816.18,
    x2: -1590.45,
    y2: 776.81,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-456",
    x1: -1535.03,
    y1: 816.78,
    x2: -1590.86,
    y2: 777.43,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-457",
    x1: -1535.24,
    y1: 817.11,
    x2: -1591.1,
    y2: 777.74,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-458",
    x1: -1535.26,
    y1: 817.09,
    x2: -1591.08,
    y2: 777.75,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-459",
    x1: -1534.99,
    y1: 816.79,
    x2: -1590.88,
    y2: 777.41,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-460",
    x1: -1534.55,
    y1: 816.18,
    x2: -1590.45,
    y2: 776.79,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-461",
    x1: -1533.97,
    y1: 815.31,
    x2: -1589.84,
    y2: 775.94,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-462",
    x1: -1533.25,
    y1: 814.29,
    x2: -1589.12,
    y2: 774.92,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-463",
    x1: -1532.49,
    y1: 813.2,
    x2: -1588.35,
    y2: 773.84,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-464",
    x1: -1531.74,
    y1: 812.15,
    x2: -1587.61,
    y2: 772.77,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-465",
    x1: -1531.09,
    y1: 811.2,
    x2: -1586.94,
    y2: 771.84,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-466",
    x1: -1537.01,
    y1: 819.64,
    x2: -1592.89,
    y2: 780.27,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-467",
    x1: -1536.7,
    y1: 819.16,
    x2: -1592.55,
    y2: 779.8,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-468",
    x1: -1536.58,
    y1: 819,
    x2: -1592.44,
    y2: 779.64,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-469",
    x1: -1536.72,
    y1: 819.15,
    x2: -1592.54,
    y2: 779.82,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-470",
    x1: -1537.03,
    y1: 819.65,
    x2: -1592.89,
    y2: 780.28,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-471",
    x1: -1537.55,
    y1: 820.39,
    x2: -1593.41,
    y2: 781.02,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-472",
    x1: -1538.2,
    y1: 821.34,
    x2: -1594.09,
    y2: 781.96,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-473",
    x1: -1538.95,
    y1: 822.41,
    x2: -1594.84,
    y2: 783.02,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-474",
    x1: -1539.72,
    y1: 823.49,
    x2: -1595.6,
    y2: 784.11,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-475",
    x1: -1540.43,
    y1: 824.51,
    x2: -1596.32,
    y2: 785.12,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-476",
    x1: -1541.04,
    y1: 825.35,
    x2: -1596.91,
    y2: 785.98,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-477",
    x1: -1541.47,
    y1: 825.96,
    x2: -1597.34,
    y2: 786.59,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-478",
    x1: -1541.7,
    y1: 826.27,
    x2: -1597.56,
    y2: 786.91,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-479",
    x1: -1541.68,
    y1: 826.28,
    x2: -1597.57,
    y2: 786.9,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-480",
    x1: -1541.46,
    y1: 825.95,
    x2: -1597.34,
    y2: 786.57,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-481",
    x1: -1541.03,
    y1: 825.33,
    x2: -1596.9,
    y2: 785.96,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-482",
    x1: -1540.43,
    y1: 824.48,
    x2: -1596.3,
    y2: 785.11,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-483",
    x1: -1539.71,
    y1: 823.46,
    x2: -1595.58,
    y2: 784.09,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-484",
    x1: -1538.93,
    y1: 822.38,
    x2: -1594.82,
    y2: 783,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-485",
    x1: -1538.19,
    y1: 821.32,
    x2: -1594.08,
    y2: 781.94,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-486",
    x1: -1537.52,
    y1: 820.38,
    x2: -1593.41,
    y2: 781,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-487",
    x1: -1529.06,
    y1: 808.35,
    x2: -1584.93,
    y2: 768.98,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-488",
    x1: -1528.67,
    y1: 807.92,
    x2: -1584.61,
    y2: 768.5,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-489",
    x1: -1528.6,
    y1: 807.73,
    x2: -1584.49,
    y2: 768.34,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-490",
    x1: -1528.7,
    y1: 807.91,
    x2: -1584.61,
    y2: 768.51,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-491",
    x1: -1529.05,
    y1: 808.37,
    x2: -1584.94,
    y2: 768.98,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-492",
    x1: -1529.61,
    y1: 809.09,
    x2: -1585.46,
    y2: 769.73,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-493",
    x1: -1530.26,
    y1: 810.04,
    x2: -1586.13,
    y2: 770.67,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-494",
    x1: -1531.02,
    y1: 811.1,
    x2: -1586.87,
    y2: 771.74,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-495",
    x1: -1531.77,
    y1: 812.2,
    x2: -1587.64,
    y2: 772.82,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-496",
    x1: -1532.49,
    y1: 813.21,
    x2: -1588.36,
    y2: 773.84,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-497",
    x1: -1533.06,
    y1: 814.07,
    x2: -1588.96,
    y2: 774.68,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-498",
    x1: -1533.52,
    y1: 814.67,
    x2: -1589.39,
    y2: 775.3,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-499",
    x1: -1533.76,
    y1: 814.97,
    x2: -1589.61,
    y2: 775.62,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-500",
    x1: -1533.71,
    y1: 815,
    x2: -1589.61,
    y2: 775.61,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-501",
    x1: -1533.53,
    y1: 814.64,
    x2: -1589.38,
    y2: 775.29,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-502",
    x1: -1533.08,
    y1: 814.04,
    x2: -1588.94,
    y2: 774.67,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-503",
    x1: -1532.46,
    y1: 813.2,
    x2: -1588.34,
    y2: 773.81,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-504",
    x1: -1531.78,
    y1: 812.16,
    x2: -1587.63,
    y2: 772.8,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-505",
    x1: -1530.99,
    y1: 811.09,
    x2: -1586.86,
    y2: 771.71,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-506",
    x1: -1530.25,
    y1: 810.02,
    x2: -1586.11,
    y2: 770.65,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-507",
    x1: -1529.56,
    y1: 809.1,
    x2: -1585.45,
    y2: 769.71,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-508",
    x1: -1586.37,
    y1: 807.96,
    x2: -1573.2,
    y2: 807.96,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-509",
    x1: -1622.66,
    y1: 519.85,
    x2: -1619.04,
    y2: 519.85,
    gradientTransform: "matrix(-1, 0.32, 0, -1, -1511.08, 1220.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-510",
    x1: -1622.66,
    y1: 525.86,
    x2: -1619.04,
    y2: 525.86,
    gradientTransform: "matrix(-1, 0.32, 0, -1, -1511.08, 1220.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-511",
    x1: -1622.66,
    y1: 531.86,
    x2: -1619.04,
    y2: 531.86,
    gradientTransform: "matrix(-1, 0.32, 0, -1, -1511.08, 1220.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-512",
    x1: -1622.66,
    y1: 537.87,
    x2: -1619.04,
    y2: 537.87,
    gradientTransform: "matrix(-1, 0.32, 0, -1, -1511.08, 1220.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-513",
    x1: -1622.66,
    y1: 543.87,
    x2: -1619.04,
    y2: 543.87,
    gradientTransform: "matrix(-1, 0.32, 0, -1, -1511.08, 1220.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-514",
    x1: -1622.66,
    y1: 549.87,
    x2: -1619.04,
    y2: 549.87,
    gradientTransform: "matrix(-1, 0.32, 0, -1, -1511.08, 1220.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-515",
    x1: -1622.66,
    y1: 555.88,
    x2: -1619.04,
    y2: 555.88,
    gradientTransform: "matrix(-1, 0.32, 0, -1, -1511.08, 1220.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-516",
    x1: -1622.66,
    y1: 561.88,
    x2: -1619.04,
    y2: 561.88,
    gradientTransform: "matrix(-1, 0.32, 0, -1, -1511.08, 1220.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-517",
    x1: -1622.66,
    y1: 567.88,
    x2: -1619.04,
    y2: 567.88,
    gradientTransform: "matrix(-1, 0.32, 0, -1, -1511.08, 1220.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-518",
    x1: -1622.66,
    y1: 573.89,
    x2: -1619.04,
    y2: 573.89,
    gradientTransform: "matrix(-1, 0.32, 0, -1, -1511.08, 1220.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-519",
    x1: -1622.66,
    y1: 579.89,
    x2: -1619.04,
    y2: 579.89,
    gradientTransform: "matrix(-1, 0.32, 0, -1, -1511.08, 1220.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-520",
    x1: -1622.66,
    y1: 585.9,
    x2: -1619.04,
    y2: 585.9,
    gradientTransform: "matrix(-1, 0.32, 0, -1, -1511.08, 1220.14)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-521",
    x1: -154.7,
    y1: 128.06,
    x2: -149.53,
    y2: 128.06,
    gradientTransform: "translate(261.97 46.28)",
    xlinkHref: "#linear-gradient-259"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-522",
    x1: -1639.51,
    y1: 765.35,
    x2: -1621.93,
    y2: 765.35,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient-259"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-523",
    x1: -1639.5,
    y1: 755.55,
    x2: -1631.93,
    y2: 755.55,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient-259"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-524",
    x1: -1629.35,
    y1: 765.6,
    x2: -1637.01,
    y2: 765.6,
    gradientTransform: "translate(-1511.08 939.95) rotate(180)",
    xlinkHref: "#linear-gradient-259"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: -1901.82,
    y: -51.82,
    width: 2406.31,
    height: 1210.9
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 153,
    height: 217,
    transform: "translate(6.64 8.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJkAAADZCAYAAAAzBJLWAAAACXBIWXMAAAsSAAALEgHS3X78AAACcElEQVR4Xu3WMQqEMABFwUT2/lfOVgqKsAv6upnOaPn4ca61xo3bQ/jDvB58Ls/i4qm9oSO27eYlvOHoaY9MYBTWGOclg8Q2rBitZcnIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYycyMiJjJzIyImMnMjIiYzcNsaYvz6CB6YlI7dHZs0ozDHO/2RC401HT9frUmi84dTRFxMoDbIIDQHrAAAAAElFTkSuQmCC"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    width: 13,
    height: 16,
    transform: "translate(17.64 48.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAQCAYAAADNo/U5AAAACXBIWXMAAAsSAAALEgHS3X78AAABoklEQVQoU3WTQY/SQBSAv5luabsUEBYVIpXszbsmu9nw78VsvHtyTURkCdEIAi10tu28PaA10PVdZvJmvveSed8oEeE0xr2BAIwWM1U5BPRTyeaLJvAPPo0KdBsNxVpLq9cCngaPoHE/Esd1qD87p/G8geu7p/erECLUApewGxK0fNqDNkopPg4vj7qV0Lg3kE7Uxgt98qxArBBe1OlEbYq84DYalqD+C3jnNVzf5eJ1B7/h49U9akGNsNug0Q0B+NCPBEC9f/lKAPpvenh1D7/pox2N4zpkaUa6STG7B0xsWM1WiMihU9gNUUqh9GEsSh1W58whaAUEfwp59Rra0ejRYqbSbYotLLv1HltYxApiBVtY9psUkzwg1pLGhpv7qdIA198majX/TW5ysn1GnuWHfZqRm4z4V8zmx7Y0pHw9Extyk2MSg80sgqCUYvl9hYkNV5OvpVIlNFrMVLJMyE1OvEzYr/fs1jtMbHh39+XIwaPhXk8navszJlkmJMsd95/miK3qV3Hv7ec7pR2NLSwAN/NpxfSz0wTAerEG/v81HgG6j8eHIdZFxwAAAABJRU5ErkJggg=="
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M24,48.56v7.88H18.15A46.79,46.79,0,0,0,24,48.56Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24,64.47v-8h5.85A47,47,0,0,0,24,64.47Z"
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 17,
    transform: "translate(136.64 170.5)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAYAAADpPU2iAAAACXBIWXMAAAsSAAALEgHS3X78AAABiElEQVQoU42S3W7aMBiGHxs7DlCgVFpLNRBM2iX0kMtnansN285QR1c2AU3SJfhnB1m8lpzUkiVL3+P3+3tFCIHTczdfBFtalpu1OI3JFg24yjGejllNpi211ocv17MIDa+Gp2HE65LuF58CwOXnDwQXsEfH4fHAzddvsbSYYTWZBm0Uo3+q5swgO5L0zHA7nUdV1Tx6ox7nH0d0h110VxN8zXjrGFwOGqzOcDdfhOHVAJ1qlFEordCpRnc1vXEP00/iAOTtbB5M32AGKR2tUIlCSFFfIdBpAkJwMbtgNZkG6Y4OW1myp2egLsM5T/ABIQVVUSKlpCqq/z2UWQkBVKoRUmL6Cd6Dt56qOOKdo9gVdQ/NNsu8JN9m2MrWAsDzNqMsSn5+f8I7z3KzFhKIFsh+5+wfdpRFxfGlIuklVHlJ8CEycQ/LzVp0VIf94wF3dOwe9vzZv8RYw72xhrOO4APZNsP0E5x1ZL/y18hbawBx3ufXI3Y/9i3HtszXAM7699sbiGM8PX8BXiu/8TVPK/8AAAAASUVORK5CYII="
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M142.71,186.8v-7.88h5.85A46.79,46.79,0,0,0,142.71,186.8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142.71,170.89v8h-5.85A47,47,0,0,0,142.71,170.89Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M22.25,29.18l8.06,8a14.68,14.68,0,0,0,3.39,2.7,7.28,7.28,0,0,0,2.8.82v.59H26.1v-.59a2.27,2.27,0,0,0,1.35-.32.89.89,0,0,0,.41-.7,1.52,1.52,0,0,0-.15-.69,6.31,6.31,0,0,0-1-1.15l-7.55-7.46v7a7.3,7.3,0,0,0,.21,2.2,1.45,1.45,0,0,0,.68.69,2.93,2.93,0,0,0,1.46.39h.75v.59H12.93v-.59h.77a2.37,2.37,0,0,0,2-.79,5.08,5.08,0,0,0,.38-2.49V23.31a7.38,7.38,0,0,0-.21-2.21,1.39,1.39,0,0,0-.66-.68A3,3,0,0,0,13.7,20h-.77v-.59h9.32V20H21.5A3.19,3.19,0,0,0,20,20.4a1.41,1.41,0,0,0-.7.78,7.34,7.34,0,0,0-.19,2.13V30L21.36,28a49.48,49.48,0,0,0,5.79-5.85A2.11,2.11,0,0,0,27.58,21a.83.83,0,0,0-.34-.66A1.83,1.83,0,0,0,26.1,20h-.5v-.59h8V20a4.71,4.71,0,0,0-1.29.2,6.1,6.1,0,0,0-1.42.68,13.8,13.8,0,0,0-2.06,1.64c-.24.21-1.33,1.32-3.28,3.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M143.87,205l-8.06-8a14.68,14.68,0,0,0-3.39-2.7,7.28,7.28,0,0,0-2.8-.82v-.59H140v.59a2.23,2.23,0,0,0-1.35.32.89.89,0,0,0-.41.7,1.52,1.52,0,0,0,.15.69,5.91,5.91,0,0,0,1,1.15L147,203.8v-7a7.3,7.3,0,0,0-.21-2.2,1.45,1.45,0,0,0-.68-.69,2.94,2.94,0,0,0-1.47-.39h-.74v-.59h9.32v.59h-.77a2.35,2.35,0,0,0-2,.79,4.9,4.9,0,0,0-.39,2.49v14.12a7.38,7.38,0,0,0,.21,2.21,1.48,1.48,0,0,0,.66.68,3.07,3.07,0,0,0,1.49.39h.77v.59h-9.32v-.59h.74a3.2,3.2,0,0,0,1.47-.37,1.43,1.43,0,0,0,.69-.78,7.23,7.23,0,0,0,.2-2.13v-6.69l-2.21,2.05a48.69,48.69,0,0,0-5.79,5.85,2.14,2.14,0,0,0-.44,1.13.83.83,0,0,0,.34.65,1.81,1.81,0,0,0,1.15.29h.5v.59h-8v-.59a4.71,4.71,0,0,0,1.29-.2,6.77,6.77,0,0,0,1.42-.68,14.91,14.91,0,0,0,2.06-1.64c.24-.21,1.33-1.32,3.27-3.31Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M98.62,73.36,127,78.72s5.62.54,5.62,7.23v25.72L33,123.19S58.13,85.69,66,79c.88-.75,4.92-1.64,9.88-2.48C85.49,74.86,98.62,73.36,98.62,73.36Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33,123.19l.9-.1,1.3-3.11C33.83,122,33,123.19,33,123.19Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35.68,119.31l1.43,3.41.9-.1-1.75-4.16Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M50.59,98.36c-.35.48-.71,1-1.06,1.45l.22.54Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M63.35,85.12l-.82-2c-1.22,1.37-2.58,3-4,4.82l1.82,4.34Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "66.93 93.65 63.9 86.44 60.88 93.65 63.9 100.86 66.93 93.65"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M65.45,80.12c-.67.62-1.43,1.4-2.28,2.33L63.82,84Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M67.4,92.54l3-7.21-2.69-6.42c-.29.09-.54.17-.77.26l-2.59,6.16Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M53.25,108.64l3-7.21L53.4,94.59l-.69.92-2.49,5.92Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "53.8 109.97 56.83 117.18 59.85 109.97 56.83 102.76 53.8 109.97"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M59.77,93.11l-1.84-4.39C56.67,90.31,55.35,92,54,93.79l2.74,6.53Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "60.32 94.43 57.3 101.64 60.32 108.85 63.35 101.64 60.32 94.43"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "60.5 111.05 57.47 118.26 58.33 120.31 62.88 119.79 63.52 118.26 60.5 111.05"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "64.05 119.66 64.11 119.65 64.08 119.58 64.05 119.66"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "60.97 109.93 63.99 117.14 67.02 109.93 63.99 102.72 60.97 109.93"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "67.57 111.25 64.55 118.47 65 119.55 70.4 118.93 70.6 118.47 67.57 111.25"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "71.62 118.77 71.63 118.79 77.41 118.13 74.65 111.56 71.62 118.77"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "75.12 110.44 78.14 117.65 81.17 110.44 78.14 103.23 75.12 110.44"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "79.13 117.94 84.08 117.37 81.72 111.76 79.13 117.94"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "67.57 94.73 64.55 101.95 67.57 109.16 70.6 101.95 67.57 94.73"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "68.13 110.48 71.15 117.69 74.18 110.48 71.15 103.27 68.13 110.48"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "74.09 93.62 71.07 86.41 68.04 93.62 71.07 100.83 74.09 93.62"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "74.65 94.94 71.62 102.15 74.65 109.36 77.67 102.15 74.65 94.94"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35.21,120l-1.3,3.11,3.2-.37-1.43-3.41Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M40,113.05c-1.43,2-2.71,3.87-3.78,5.41L38,122.62l2.25-.25,1.85-4.4Z"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "46.16 111.07 43.13 118.28 44.64 121.87 47.83 121.5 49.18 118.28 46.16 111.07"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "48.99 121.37 50.41 121.21 49.74 119.6 48.99 121.37"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "46.63 109.95 49.65 117.16 52.68 109.95 49.65 102.74 46.63 109.95"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "53.23 111.27 50.21 118.48 51.31 121.11 55.35 120.65 56.26 118.48 53.23 111.27"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "41.23 122.25 43.8 121.96 42.58 119.05 41.23 122.25"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M45.69,110l-1.3-3.08c-1.33,1.87-2.61,3.67-3.8,5.36l2.07,4.93Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M49.18,101.66l-.37-.88c-1.3,1.78-2.58,3.56-3.82,5.29l1.17,2.8Z"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "56.5 120.52 57.26 120.43 56.9 119.56 56.5 120.52"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M74.06,77.52c-2.14.39-4,.77-5.46,1.15l2.49,5.93Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M81.78,76.29l-.23,0,.11.25Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M85.24,85.11l3-7.21-1-2.37c-1.4.18-2.85.38-4.31.59l-.75,1.78Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M89.37,75.25l-1.21.16.57,1.37Z"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "77.61 85.68 74.58 78.47 71.56 85.68 74.58 92.89 77.61 85.68"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "78.16 101.42 81.19 94.21 78.16 87 75.14 94.21 78.16 101.42"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M78.08,84.56l3-7.21-.38-.9c-1.67.25-3.32.5-4.88.77l-.79.13h0Z"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "84.68 85.88 81.66 78.67 78.63 85.88 81.66 93.09 84.68 85.88"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "78.81 102.5 81.83 109.71 84.86 102.5 81.83 95.29 78.81 102.5"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "85.41 103.83 82.39 111.03 85 117.27 85.86 117.17 88.44 111.03 85.41 103.83"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "85.33 86.97 82.3 94.18 85.33 101.39 88.35 94.18 85.33 86.97"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "85.88 102.71 88.91 109.92 91.93 102.71 88.91 95.5 85.88 102.71"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "92.96 103.01 95.98 110.22 99.01 103.01 95.98 95.8 92.96 103.01"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "99.56 104.33 96.54 111.54 98.3 115.75 100.95 115.45 102.59 111.54 99.56 104.33"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "99.47 87.47 96.45 94.69 99.47 101.9 102.5 94.69 99.47 87.47"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "100.03 103.22 103.06 110.43 106.08 103.22 103.06 96.01 100.03 103.22"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "86.83 117.06 90.79 116.61 88.91 112.12 86.83 117.06"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "92.4 103.79 89.38 111 91.69 116.51 93.19 116.34 95.43 111 92.4 103.79"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "94.35 116.2 97.46 115.85 95.98 112.32 94.35 116.2"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "91.93 86.19 88.91 78.98 85.88 86.19 88.91 93.4 91.93 86.19"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "92.49 87.51 89.46 94.72 92.49 101.93 95.51 94.72 92.49 87.51"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.4,85.07l3-7.21-1.35-3.2-3.55.44-1.16,2.76Z"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "99.01 86.39 95.98 79.18 92.95 86.39 95.98 93.6 99.01 86.39"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M78.08,75.63l-5.6,1.29S73.83,88.7,90.86,89.1s28.23-12.59,28.23-12.59l-8-.88s-11.94,7.58-20.23,6.16A24.2,24.2,0,0,1,78.08,75.63Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M92.43,35.35,72.69,36.92l.51,2.18L70.71,52.86l2.71.72L73,56.71l2.3,1.47L75.16,60s2.55,1.07,1.06,2.58-2.8,4.39,4.3,4.79c4.32.24,6.52,2.26,2.91,8.44,0-.57,3,4,7.65,4.3,7.18.41,17.15-3.21,17.15-3.21S92.77,41.09,92.43,35.35Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M73.69,39.43a2.28,2.28,0,0,0,1.24,2.91,12.26,12.26,0,0,0,2.75-.83c1.62-.67,5.17-.23,5.65.35s-1-3.29-6.62-1.62C73.23,41.27,73.69,39.43,73.69,39.43Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.65,42.84a6.1,6.1,0,0,0,3.26-.08c1.62-.55,3.85-.43,4.93.57a9.14,9.14,0,0,0-4.3.27s.56,2-.66,2.21-1.3-2-1.3-2A3.17,3.17,0,0,1,74.65,42.84Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M90.11,34.81S92,62.12,88,63.74c0,0-4.3,4.35-2.27,6.88,2.44,3,12.41,4.21,28.57,1.75,0,0,6.43-4.75-1.32-14-2.28-2.72-5.75-12.75-2.78-23.53Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M114.43,75.64l-38.57,43,56.75-7V82.07A11.62,11.62,0,0,0,127,78.72C123.74,78.05,114.43,75.64,114.43,75.64Z"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.43 75.64 75.86 118.64 53.26 121.15 112.66 75.64 114.43 75.64"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M84.73,72.69l-6.21,3.08s5.32,7.91,15.08,7.37,17.58-7.37,17.58-7.37l-4.72-2.61S100.1,77.65,93,77.78,84.73,72.69,84.73,72.69Z"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "90.91 82.62 93.05 80.71 91.95 78.18 91.95 78.18 91.95 78.18 91.95 78.18 91.95 78.18 89.82 80.09 90.91 82.62 90.91 82.62 90.91 82.62 90.91 82.62 90.91 82.62"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-12",
    points: "95.85 82.53 97.36 80.19 95.59 78 95.59 78 95.59 78 95.59 78 95.59 78 94.07 80.34 95.85 82.53 95.85 82.53 95.85 82.53 95.85 82.53 95.85 82.53"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "100.84 81.47 101.56 78.83 99.17 77.19 99.17 77.19 99.17 77.19 99.17 77.19 99.17 77.19 98.45 79.83 100.84 81.47 100.84 81.47 100.84 81.47 100.84 81.47 100.84 81.47"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "104.6 79.92 105.05 77.23 102.5 75.79 102.5 75.79 102.5 75.79 102.5 75.79 102.5 75.79 102.05 78.48 104.6 79.92 104.6 79.92 104.6 79.92 104.6 79.92 104.6 79.92"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "86.14 81.21 88.76 79.88 88.45 77.18 88.45 77.18 88.45 77.18 88.45 77.18 88.45 77.18 85.83 78.5 86.14 81.21 86.14 81.21 86.14 81.21 86.14 81.21 86.14 81.21"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "82.43 78.94 85.37 78.37 85.95 75.7 85.95 75.7 85.95 75.7 85.95 75.7 85.95 75.7 83.02 76.27 82.43 78.94 82.43 78.94 82.43 78.94 82.43 78.94 82.43 78.94"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M110.21,34.84s-3,16.28,4.28,24.78,1,13.75-3.75,13.5c0,0,6.25-1.25,4.5-7.5S104.94,54.56,110.21,34.84Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M90.11,34.81S92.27,59.36,88,63.74s-3.77,6.88-1,8.38c0,0-1.91-3.38,1.5-7.5C94.49,57.37,90.11,34.81,90.11,34.81Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M95.74,35.87s2.5,26,.5,28.5c0,0-2.25,7.25.25,8.5,0,0-1-5,1.25-8.5S95.74,35.87,95.74,35.87Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M105.49,38.62s-1,19.25,1.75,23,1.45,11.83-.78,11.54c0,0,3-6.6-.72-12C103,57.12,105.49,38.62,105.49,38.62Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M72.69,36.92S99,34,110.36,36.37l3.63-11s-5.75,1.37-8-3.25c0,0-7.5,5.37-13.13-1.13,0,0-6.75,6.13-11.87.13,0,0-6.38,7.75-12.38,1.87Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M72.49,36.37s13-3.63,38.25-1l-.38,1.87S88.6,35.37,73,38Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M81,21.12S74.61,29.24,68.61,23L73,38l-2.63-12.5S76.49,28.37,81,21.12Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M92.86,21A10.57,10.57,0,0,0,106,22.12s2.25,4.37,8,3.25c0,0-5.13,2.5-8.13-2.13C105.86,23.24,98.11,28.24,92.86,21Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.32,46.29s1.64,2.33,4.5.33C80.82,46.62,77.14,47.45,76.32,46.29Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M73,56.71a10.45,10.45,0,0,1,4.82.16s1,5.12.25,5.62l-1.89,0a5.3,5.3,0,0,0-1.73,4.09,6.24,6.24,0,0,1,2-.25l4-1.38-1.13-8.62a4.12,4.12,0,0,0-3.5-1.5,13.16,13.16,0,0,1-2.5-.25Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M73,77.05s1.84,13.4,22.34,11.74L93,90.45s-18.83,3.5-22.17-13Z"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "97.36 87.12 112.66 75.64 127.11 112.37 105.86 115 97.36 87.12"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-25"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "111.46 109.01 110.75 110.73 111.46 112.45 112.17 110.73 111.46 109.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-27",
    points: "113.28 109.31 112.1 110.74 112.27 112.6 113.46 111.16 113.28 109.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "114.94 110.13 113.38 111.15 113 112.97 114.55 111.95 114.94 110.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "116.27 111.4 114.48 111.92 113.58 113.55 115.37 113.03 116.27 111.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-30",
    points: "117.18 113.01 115.31 112.98 113.97 114.27 115.83 114.3 117.18 113.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "117.56 114.82 115.79 114.23 114.13 115.07 115.9 115.66 117.56 114.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "117.4 116.66 115.88 115.58 114.04 115.89 115.56 116.97 117.4 116.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "116.7 118.37 115.57 116.89 113.72 116.64 114.86 118.12 116.7 118.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "115.53 119.79 114.89 118.05 113.19 117.27 113.84 119.01 115.53 119.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "113.99 120.81 113.89 118.95 112.5 117.71 112.61 119.57 113.99 120.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "112.22 121.33 112.67 119.52 111.71 117.93 111.26 119.73 112.22 121.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "110.38 121.31 111.34 119.71 110.89 117.9 109.93 119.5 110.38 121.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "108.62 120.74 110.01 119.5 110.12 117.64 108.73 118.88 108.62 120.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "107.11 119.68 108.8 118.9 109.45 117.16 107.76 117.93 107.11 119.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "105.98 118.22 107.83 117.98 108.96 116.5 107.12 116.74 105.98 118.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "105.33 116.49 107.17 116.81 108.69 115.73 106.85 115.42 105.33 116.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "105.22 114.65 106.88 115.49 108.65 114.91 106.99 114.07 105.22 114.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "105.65 112.85 106.99 114.15 108.86 114.12 107.52 112.83 105.65 112.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "106.6 111.27 107.5 112.9 109.29 113.42 108.39 111.79 106.6 111.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "107.97 110.03 108.35 111.86 109.91 112.88 109.53 111.06 107.97 110.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "109.64 109.26 109.47 111.11 110.65 112.55 110.83 110.7 109.64 109.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "119.32 100.84 118.61 102.57 119.32 104.29 120.03 102.57 119.32 100.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "121.14 101.14 119.95 102.58 120.12 104.43 121.31 103 121.14 101.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "122.79 101.96 121.23 102.99 120.85 104.81 122.41 103.79 122.79 101.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "124.13 103.24 122.34 103.75 121.44 105.38 123.22 104.87 124.13 103.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "125.03 104.85 123.17 104.81 121.82 106.11 123.69 106.14 125.03 104.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "125.42 106.65 123.65 106.07 121.98 106.91 123.75 107.49 125.42 106.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "125.26 108.49 123.73 107.41 121.9 107.72 123.42 108.8 125.26 108.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-54",
    points: "124.56 110.2 123.42 108.72 121.58 108.48 122.71 109.95 124.56 110.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "123.39 111.63 122.74 109.88 121.05 109.1 121.7 110.85 123.39 111.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "121.85 112.65 121.75 110.79 120.36 109.55 120.46 111.41 121.85 112.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "120.08 113.17 120.53 111.36 119.57 109.76 119.12 111.57 120.08 113.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-58",
    points: "118.23 113.14 119.19 111.55 118.75 109.74 117.79 111.33 118.23 113.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "116.47 112.58 117.86 111.33 117.97 109.47 116.58 110.72 116.47 112.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "114.97 111.51 116.66 110.74 117.31 108.99 115.62 109.77 114.97 111.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "113.83 110.06 115.68 109.81 116.82 108.34 114.97 108.58 113.83 110.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "113.18 108.33 115.02 108.64 116.54 107.56 114.7 107.25 113.18 108.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "113.07 106.48 114.73 107.33 116.5 106.75 114.84 105.91 113.07 106.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "113.51 104.69 114.85 105.98 116.71 105.95 115.37 104.66 113.51 104.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-65",
    points: "114.45 103.11 115.35 104.74 117.14 105.26 116.24 103.63 114.45 103.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "115.82 101.87 116.2 103.69 117.76 104.72 117.38 102.89 115.82 101.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "117.5 101.09 117.32 102.95 118.51 104.39 118.68 102.53 117.5 101.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "122.86 111.68 122.15 113.4 122.86 115.12 123.58 113.4 122.86 111.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-69",
    points: "124.69 111.98 123.5 113.41 123.67 115.27 124.86 113.83 124.69 111.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "126.34 112.8 124.78 113.82 124.4 115.64 125.96 114.62 126.34 112.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "127.68 114.07 125.89 114.59 124.98 116.22 126.77 115.7 127.68 114.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "128.58 115.68 126.72 115.65 125.37 116.94 127.23 116.97 128.58 115.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "128.97 117.49 127.19 116.91 125.53 117.74 127.3 118.33 128.97 117.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-74",
    points: "128.8 119.33 127.28 118.25 125.45 118.56 126.97 119.64 128.8 119.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-75",
    points: "128.11 121.04 126.97 119.56 125.13 119.31 126.26 120.79 128.11 121.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-76",
    points: "126.94 122.46 126.29 120.72 124.59 119.94 125.24 121.68 126.94 122.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-77",
    points: "125.4 123.48 125.29 121.62 123.91 120.38 124.01 122.24 125.4 123.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-78",
    points: "123.63 124 124.07 122.2 123.11 120.6 122.67 122.41 123.63 124"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "121.78 123.98 122.74 122.38 122.3 120.57 121.33 122.17 121.78 123.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-80",
    points: "120.02 123.41 121.41 122.17 121.52 120.31 120.13 121.55 120.02 123.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-81",
    points: "118.51 122.35 120.21 121.57 120.86 119.83 119.16 120.6 118.51 122.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-82",
    points: "117.38 120.89 119.23 120.65 120.37 119.17 118.52 119.41 117.38 120.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-83",
    points: "116.73 119.16 118.57 119.47 120.09 118.4 118.25 118.09 116.73 119.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-84",
    points: "116.62 117.32 118.28 118.16 120.05 117.58 118.39 116.74 116.62 117.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-85",
    points: "117.06 115.53 118.4 116.82 120.26 116.79 118.92 115.5 117.06 115.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-86",
    points: "118 113.94 118.9 115.57 120.69 116.09 119.79 114.46 118 113.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-87",
    points: "119.37 112.7 119.75 114.53 121.31 115.55 120.93 113.73 119.37 112.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-88",
    points: "121.05 111.93 120.87 113.78 122.06 115.22 122.23 113.37 121.05 111.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "114.82 119.73 114.11 121.45 114.82 123.17 115.53 121.45 114.82 119.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-90",
    points: "116.64 120.03 115.45 121.46 115.63 123.32 116.81 121.88 116.64 120.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-91",
    points: "118.3 120.85 116.74 121.87 116.35 123.69 117.91 122.67 118.3 120.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-92",
    points: "119.63 122.12 117.84 122.64 116.94 124.27 118.73 123.75 119.63 122.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-93",
    points: "120.53 123.73 118.67 123.7 117.33 124.99 119.19 125.02 120.53 123.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-94",
    points: "120.92 125.54 119.15 124.95 117.49 125.79 119.26 126.38 120.92 125.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "120.76 127.38 119.24 126.3 117.4 126.61 118.92 127.69 120.76 127.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-96",
    points: "120.06 129.09 118.93 127.61 117.08 127.36 118.22 128.84 120.06 129.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-97",
    points: "118.89 130.51 118.24 128.77 116.55 127.99 117.2 129.73 118.89 130.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-98",
    points: "117.35 131.53 117.25 129.67 115.86 128.43 115.97 130.29 117.35 131.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-99",
    points: "115.58 132.05 116.03 130.25 115.07 128.65 114.62 130.46 115.58 132.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-100",
    points: "113.73 132.03 114.7 130.43 114.25 128.62 113.29 130.22 113.73 132.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-101",
    points: "111.98 131.46 113.37 130.22 113.48 128.36 112.09 129.6 111.98 131.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-102",
    points: "110.47 130.4 112.16 129.62 112.81 127.88 111.12 128.66 110.47 130.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-103",
    points: "109.34 128.94 111.19 128.7 112.32 127.22 110.47 127.46 109.34 128.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-104",
    points: "108.69 127.21 110.52 127.53 112.05 126.45 110.21 126.14 108.69 127.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-105",
    points: "108.58 125.37 110.24 126.21 112.01 125.63 110.35 124.79 108.58 125.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-106",
    points: "109.01 123.58 110.35 124.87 112.22 124.84 110.88 123.55 109.01 123.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-107",
    points: "109.96 121.99 110.86 123.62 112.64 124.14 111.75 122.51 109.96 121.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-108",
    points: "111.33 120.75 111.71 122.58 113.26 123.6 112.88 121.78 111.33 120.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-109",
    points: "113 119.98 112.83 121.83 114.01 123.27 114.19 121.41 113 119.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-110",
    points: "108.13 98.12 107.42 99.84 108.13 101.56 108.84 99.84 108.13 98.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-111",
    points: "109.96 98.42 108.77 99.85 108.94 101.71 110.13 100.27 109.96 98.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-112",
    points: "111.61 99.24 110.05 100.26 109.67 102.09 111.23 101.06 111.61 99.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-113",
    points: "112.95 100.51 111.16 101.03 110.25 102.66 112.04 102.14 112.95 100.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "113.85 102.13 111.99 102.09 110.64 103.38 112.5 103.41 113.85 102.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-115",
    points: "114.23 103.93 112.47 103.35 110.8 104.19 112.57 104.77 114.23 103.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-116",
    points: "114.07 105.77 112.55 104.69 110.72 105 112.24 106.08 114.07 105.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "113.38 107.48 112.24 106 110.39 105.75 111.53 107.23 113.38 107.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-118",
    points: "112.21 108.91 111.56 107.16 109.87 106.38 110.51 108.13 112.21 108.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "110.67 109.92 110.56 108.06 109.18 106.82 109.28 108.68 110.67 109.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-120",
    points: "108.89 110.45 109.34 108.64 108.39 107.04 107.94 108.85 108.89 110.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-121",
    points: "107.05 110.42 108.01 108.83 107.57 107.02 106.6 108.61 107.05 110.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "105.29 109.85 106.68 108.61 106.79 106.75 105.4 107.99 105.29 109.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-123",
    points: "103.78 108.79 105.48 108.02 106.13 106.27 104.43 107.05 103.78 108.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "102.65 107.33 104.5 107.09 105.64 105.61 103.79 105.86 102.65 107.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "102 105.6 103.84 105.92 105.36 104.84 103.52 104.53 102 105.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-126",
    points: "101.89 103.76 103.55 104.6 105.32 104.02 103.66 103.18 101.89 103.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-127",
    points: "102.33 101.97 103.67 103.26 105.53 103.23 104.19 101.94 102.33 101.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-128",
    points: "103.27 100.38 104.17 102.01 105.96 102.54 105.06 100.9 103.27 100.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-129",
    points: "104.64 99.15 105.02 100.97 106.58 102 106.2 100.17 104.64 99.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-130",
    points: "106.32 98.37 106.14 100.22 107.33 101.66 107.5 99.81 106.32 98.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-131",
    points: "116.19 89.41 115.48 91.13 116.19 92.85 116.9 91.13 116.19 89.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-132",
    points: "118.01 89.71 116.83 91.14 117 93 118.18 91.56 118.01 89.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-133",
    points: "119.67 90.53 118.11 91.55 117.72 93.38 119.28 92.36 119.67 90.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-134",
    points: "121 91.81 119.21 92.32 118.31 93.95 120.1 93.44 121 91.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-135",
    points: "121.91 93.41 120.04 93.38 118.7 94.67 120.56 94.7 121.91 93.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-136",
    points: "122.29 95.22 120.52 94.64 118.86 95.47 120.63 96.06 122.29 95.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-137",
    points: "122.13 97.06 120.61 95.98 118.77 96.29 120.29 97.37 122.13 97.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-138",
    points: "121.43 98.77 120.3 97.29 118.45 97.04 119.59 98.52 121.43 98.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-139",
    points: "120.26 100.2 119.61 98.45 117.92 97.67 118.57 99.42 120.26 100.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "118.72 101.22 118.62 99.35 117.23 98.11 117.34 99.97 118.72 101.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-141",
    points: "116.95 101.74 117.4 99.93 116.44 98.33 115.99 100.14 116.95 101.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-142",
    points: "115.11 101.71 116.07 100.11 115.62 98.31 114.66 99.9 115.11 101.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-143",
    points: "113.35 101.14 114.74 99.9 114.85 98.04 113.46 99.28 113.35 101.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-144",
    points: "111.84 100.08 113.53 99.31 114.18 97.56 112.49 98.34 111.84 100.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-145",
    points: "110.71 98.62 112.56 98.38 113.69 96.9 111.84 97.14 110.71 98.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-146",
    points: "110.06 96.89 111.89 97.21 113.42 96.13 111.58 95.82 110.06 96.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-147",
    points: "109.95 95.05 111.61 95.89 113.38 95.31 111.72 94.47 109.95 95.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-148",
    points: "110.38 93.26 111.72 94.55 113.59 94.52 112.25 93.23 110.38 93.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-149",
    points: "111.33 91.67 112.23 93.31 114.02 93.83 113.12 92.19 111.33 91.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-150",
    points: "112.7 90.44 113.08 92.26 114.63 93.28 114.26 91.46 112.7 90.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-151",
    points: "114.37 89.66 114.2 91.52 115.38 92.95 115.56 91.1 114.37 89.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-152",
    points: "101.17 76.32 100.46 78.04 101.17 79.76 101.89 78.04 101.17 76.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-153",
    points: "103 76.62 101.81 78.05 101.98 79.91 103.17 78.47 103 76.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-154",
    points: "104.65 77.44 103.09 78.46 102.71 80.28 104.27 79.26 104.65 77.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-155",
    points: "105.99 78.71 104.2 79.23 103.29 80.86 105.08 80.34 105.99 78.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-156",
    points: "106.89 80.32 105.03 80.29 103.68 81.58 105.55 81.61 106.89 80.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-157",
    points: "107.28 82.13 105.51 81.55 103.84 82.38 105.61 82.97 107.28 82.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-158",
    points: "107.11 83.97 105.59 82.89 103.76 83.2 105.28 84.28 107.11 83.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-159",
    points: "106.42 85.68 105.28 84.2 103.44 83.95 104.57 85.43 106.42 85.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-160",
    points: "105.25 87.1 104.6 85.36 102.91 84.58 103.55 86.33 105.25 87.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-161",
    points: "103.71 88.12 103.6 86.26 102.22 85.02 102.32 86.88 103.71 88.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-162",
    points: "101.94 88.64 102.38 86.83 101.43 85.24 100.98 87.05 101.94 88.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-163",
    points: "100.09 88.62 101.05 87.02 100.61 85.21 99.64 86.81 100.09 88.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-164",
    points: "98.33 88.05 99.72 86.81 99.83 84.95 98.44 86.19 98.33 88.05"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-165",
    points: "96.82 86.99 98.52 86.21 99.17 84.47 97.47 85.24 96.82 86.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-166",
    points: "95.69 85.53 97.54 85.29 98.68 83.81 96.83 84.05 95.69 85.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-167",
    points: "95.04 83.8 96.88 84.12 98.4 83.04 96.56 82.73 95.04 83.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-168",
    points: "94.93 81.96 96.59 82.8 98.36 82.22 96.7 81.38 94.93 81.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-169",
    points: "95.37 80.17 96.71 81.46 98.57 81.43 97.23 80.14 95.37 80.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-170",
    points: "96.31 78.58 97.21 80.21 99 80.73 98.1 79.1 96.31 78.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-171",
    points: "97.68 77.34 98.06 79.17 99.62 80.19 99.24 78.37 97.68 77.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-172",
    points: "99.36 76.57 99.18 78.42 100.37 79.86 100.54 78.01 99.36 76.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-173",
    points: "109.03 68.16 108.32 69.88 109.03 71.6 109.74 69.88 109.03 68.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-174",
    points: "110.85 68.45 109.66 69.89 109.84 71.74 111.02 70.31 110.85 68.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-175",
    points: "112.5 69.27 110.95 70.3 110.56 72.12 112.12 71.1 112.5 69.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-176",
    points: "113.84 70.55 112.05 71.06 111.15 72.69 112.94 72.18 113.84 70.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-177",
    points: "114.74 72.16 112.88 72.13 111.54 73.42 113.4 73.45 114.74 72.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-178",
    points: "115.13 73.96 113.36 73.38 111.7 74.22 113.47 74.8 115.13 73.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-179",
    points: "114.97 75.8 113.45 74.72 111.61 75.03 113.13 76.11 114.97 75.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-180",
    points: "114.27 77.51 113.14 76.03 111.29 75.79 112.42 77.27 114.27 77.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-181",
    points: "113.1 78.94 112.45 77.19 110.76 76.41 111.41 78.16 113.1 78.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-182",
    points: "111.56 79.96 111.46 78.1 110.07 76.86 110.17 78.72 111.56 79.96"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-183",
    points: "109.79 80.48 110.24 78.67 109.28 77.07 108.83 78.88 109.79 80.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-184",
    points: "107.94 80.45 108.91 78.86 108.46 77.05 107.5 78.64 107.94 80.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-185",
    points: "106.19 79.89 107.58 78.64 107.69 76.79 106.3 78.03 106.19 79.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-186",
    points: "104.68 78.83 106.37 78.05 107.02 76.3 105.33 77.08 104.68 78.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-187",
    points: "103.55 77.37 105.39 77.12 106.53 75.65 104.68 75.89 103.55 77.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-188",
    points: "102.9 75.64 104.73 75.95 106.25 74.88 104.42 74.56 102.9 75.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-189",
    points: "102.78 73.8 104.45 74.64 106.22 74.06 104.56 73.22 102.78 73.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-190",
    points: "103.22 72 104.56 73.3 106.42 73.27 105.08 71.97 103.22 72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-191",
    points: "104.17 70.42 105.07 72.05 106.86 72.57 105.96 70.94 104.17 70.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-192",
    points: "105.54 69.18 105.92 71 107.47 72.03 107.09 70.2 105.54 69.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-193",
    points: "107.21 68.4 107.04 70.26 108.22 71.7 108.4 69.84 107.21 68.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-194",
    points: "112.58 78.99 111.86 80.71 112.58 82.43 113.29 80.71 112.58 78.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-195",
    points: "114.4 79.29 113.21 80.72 113.38 82.58 114.57 81.14 114.4 79.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-196",
    points: "116.05 80.11 114.49 81.13 114.11 82.95 115.67 81.93 116.05 80.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-197",
    points: "117.39 81.38 115.6 81.9 114.7 83.53 116.48 83.01 117.39 81.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-198",
    points: "118.29 82.99 116.43 82.96 115.08 84.25 116.95 84.28 118.29 82.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-199",
    points: "118.68 84.8 116.91 84.22 115.24 85.05 117.01 85.64 118.68 84.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-200",
    points: "118.52 86.64 117 85.56 115.16 85.87 116.68 86.95 118.52 86.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-201",
    points: "117.82 88.35 116.68 86.87 114.84 86.62 115.97 88.1 117.82 88.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-202",
    points: "116.65 89.77 116 88.03 114.31 87.25 114.96 89 116.65 89.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-203",
    points: "115.11 90.79 115 88.93 113.62 87.69 113.72 89.55 115.11 90.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-204",
    points: "113.34 91.31 113.79 89.51 112.83 87.91 112.38 89.72 113.34 91.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-205",
    points: "111.49 91.29 112.45 89.69 112.01 87.88 111.05 89.48 111.49 91.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-206",
    points: "109.74 90.72 111.13 89.48 111.23 87.62 109.84 88.86 109.74 90.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-207",
    points: "108.23 89.66 109.92 88.88 110.57 87.14 108.88 87.91 108.23 89.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-208",
    points: "107.09 88.2 108.94 87.96 110.08 86.48 108.23 86.72 107.09 88.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-209",
    points: "106.44 86.47 108.28 86.79 109.8 85.71 107.97 85.4 106.44 86.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-210",
    points: "106.33 84.63 108 85.47 109.77 84.89 108.1 84.05 106.33 84.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-211",
    points: "106.77 82.84 108.11 84.13 109.97 84.1 108.63 82.81 106.77 82.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-212",
    points: "107.71 81.25 108.61 82.88 110.4 83.4 109.5 81.77 107.71 81.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-213",
    points: "109.08 80.01 109.47 81.84 111.02 82.86 110.64 81.04 109.08 80.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-214",
    points: "110.76 79.24 110.58 81.09 111.77 82.53 111.94 80.68 110.76 79.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-215",
    points: "104.53 87.04 103.82 88.76 104.53 90.48 105.24 88.76 104.53 87.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-216",
    points: "106.35 87.34 105.17 88.77 105.34 90.63 106.53 89.19 106.35 87.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-217",
    points: "108.01 88.16 106.45 89.18 106.07 91 107.63 89.98 108.01 88.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-218",
    points: "109.34 89.43 107.55 89.95 106.65 91.58 108.44 91.06 109.34 89.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-219",
    points: "110.25 91.04 108.38 91.01 107.04 92.3 108.9 92.33 110.25 91.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-220",
    points: "110.63 92.85 108.86 92.27 107.2 93.1 108.97 93.69 110.63 92.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-221",
    points: "110.47 94.69 108.95 93.61 107.11 93.92 108.63 95 110.47 94.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-222",
    points: "109.77 96.4 108.64 94.92 106.79 94.67 107.93 96.15 109.77 96.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-223",
    points: "108.6 97.83 107.96 96.08 106.26 95.3 106.91 97.04 108.6 97.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-224",
    points: "107.06 98.84 106.96 96.98 105.57 95.74 105.68 97.6 107.06 98.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-225",
    points: "105.3 99.36 105.74 97.56 104.78 95.96 104.33 97.77 105.3 99.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-226",
    points: "103.45 99.34 104.41 97.74 103.97 95.93 103 97.53 103.45 99.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-227",
    points: "101.69 98.77 103.08 97.53 103.19 95.67 101.8 96.91 101.69 98.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-228",
    points: "100.18 97.71 101.88 96.93 102.53 95.19 100.83 95.97 100.18 97.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-229",
    points: "99.05 96.25 100.9 96.01 102.03 94.53 100.19 94.77 99.05 96.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-230",
    points: "98.4 94.52 100.24 94.84 101.76 93.76 99.92 93.45 98.4 94.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-231",
    points: "98.29 92.68 99.95 93.52 101.72 92.94 100.06 92.1 98.29 92.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-232",
    points: "98.72 90.89 100.06 92.18 101.93 92.15 100.59 90.86 98.72 90.89"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-233",
    points: "99.67 89.3 100.57 90.93 102.36 91.45 101.46 89.82 99.67 89.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-234",
    points: "101.04 88.06 101.42 89.89 102.97 90.91 102.6 89.09 101.04 88.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-235",
    points: "102.72 87.29 102.54 89.14 103.72 90.58 103.9 88.73 102.72 87.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-236",
    points: "97.85 65.43 97.14 67.15 97.85 68.87 98.56 67.15 97.85 65.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-237",
    points: "99.67 65.73 98.48 67.16 98.65 69.02 99.84 67.58 99.67 65.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-238",
    points: "101.32 66.55 99.76 67.58 99.38 69.4 100.94 68.38 101.32 66.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-239",
    points: "102.66 67.83 100.87 68.34 99.97 69.97 101.76 69.45 102.66 67.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-240",
    points: "103.56 69.44 101.7 69.4 100.36 70.69 102.22 70.72 103.56 69.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-241",
    points: "103.95 71.24 102.18 70.66 100.51 71.5 102.28 72.08 103.95 71.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-242",
    points: "103.79 73.08 102.27 72 100.43 72.31 101.95 73.39 103.79 73.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-243",
    points: "103.09 74.79 101.95 73.31 100.11 73.06 101.24 74.54 103.09 74.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-244",
    points: "101.92 76.22 101.27 74.47 99.58 73.69 100.23 75.44 101.92 76.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-245",
    points: "100.38 77.24 100.28 75.37 98.89 74.13 98.99 75.99 100.38 77.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-246",
    points: "98.61 77.76 99.06 75.95 98.1 74.35 97.65 76.16 98.61 77.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-247",
    points: "96.76 77.73 97.72 76.14 97.28 74.33 96.32 75.92 96.76 77.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-248",
    points: "95.01 77.16 96.4 75.92 96.5 74.06 95.11 75.3 95.01 77.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-249",
    points: "93.5 76.1 95.19 75.33 95.84 73.58 94.15 74.36 93.5 76.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-250",
    points: "92.36 74.64 94.21 74.4 95.35 72.92 93.5 73.17 92.36 74.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-251",
    points: "91.72 72.92 93.55 73.23 95.07 72.15 93.24 71.84 91.72 72.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-252",
    points: "91.6 71.07 93.27 71.91 95.04 71.33 93.37 70.49 91.6 71.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-253",
    points: "92.04 69.28 93.38 70.57 95.24 70.54 93.9 69.25 92.04 69.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-254",
    points: "92.98 67.69 93.88 69.33 95.67 69.84 94.77 68.21 92.98 67.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-255",
    points: "94.36 66.46 94.73 68.28 96.29 69.31 95.91 67.48 94.36 66.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-256",
    points: "96.03 65.68 95.85 67.54 97.04 68.97 97.22 67.12 96.03 65.68"
  }))), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "97.36 87.25 105.86 115.12 103.99 115.12 95.32 88.79 97.36 87.25"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-257",
    points: "90.82 92.29 95.32 88.79 103.99 115.12 99.16 115.62 90.82 92.29"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "87.01 101.61 89.9 101.47 90.74 98.96 90.74 98.96 90.74 98.96 90.74 98.96 90.74 98.96 87.85 99.1 87.01 101.61 87.01 101.61 87.01 101.61 87.01 101.61 87.01 101.61"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "82.8 104.61 85.69 104.47 86.53 101.96 86.53 101.96 86.53 101.96 86.53 101.96 86.53 101.96 83.64 102.1 82.8 104.61 82.8 104.61 82.8 104.61 82.8 104.61 82.8 104.61"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "78.59 107.61 81.48 107.47 82.32 104.95 82.32 104.95 82.32 104.95 82.32 104.95 82.32 104.95 79.44 105.1 78.59 107.61 78.59 107.61 78.59 107.61 78.59 107.61 78.59 107.61"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "74.76 110.36 77.65 110.22 78.49 107.71 78.49 107.71 78.49 107.71 78.49 107.71 78.49 107.71 75.6 107.85 74.76 110.36 74.76 110.36 74.76 110.36 74.76 110.36 74.76 110.36"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "70.55 113.36 73.44 113.22 74.28 110.71 74.28 110.71 74.28 110.71 74.28 110.71 74.28 110.71 71.39 110.85 70.55 113.36 70.55 113.36 70.55 113.36 70.55 113.36 70.55 113.36"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "66.34 116.36 69.23 116.22 70.07 113.7 70.07 113.7 70.07 113.7 70.07 113.7 70.07 113.7 67.19 113.85 66.34 116.36 66.34 116.36 66.34 116.36 66.34 116.36 66.34 116.36"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "90.82 92.2 51.57 121.29 55.69 120.95 91.57 94.37 90.82 92.2"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.16 50.16 54.53 51.98 54.53 48.98 58.16 47.16 58.16 50.16"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-258",
    points: "58.16 53.17 54.53 54.98 54.53 51.98 58.16 50.16 58.16 53.17"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.16 56.17 54.53 57.98 54.53 54.98 58.16 53.17 58.16 56.17"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-259",
    points: "58.16 59.17 54.53 60.98 54.53 57.98 58.16 56.17 58.16 59.17"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.16 62.17 54.53 63.99 54.53 60.98 58.16 59.17 58.16 62.17"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-260",
    points: "58.16 65.17 54.53 66.99 54.53 63.99 58.16 62.17 58.16 65.17"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.16 68.18 54.53 69.99 54.53 66.99 58.16 65.17 58.16 68.18"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-261",
    points: "58.16 71.18 54.53 72.99 54.53 69.99 58.16 68.18 58.16 71.18"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.16 74.18 54.53 76 54.53 72.99 58.16 71.18 58.16 74.18"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-262",
    points: "58.16 77.18 54.53 79 54.53 76 58.16 74.18 58.16 77.18"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.16 80.18 54.53 82 54.53 79 58.16 77.18 58.16 80.18"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-263",
    points: "58.16 83.19 54.53 85 54.53 82 58.16 80.18 58.16 83.19"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.16 86.19 54.53 88 54.53 85 58.16 83.19 58.16 86.19"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-264",
    points: "58.16 89.19 54.53 91 54.53 88 58.16 86.19 58.16 89.19"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.16 92.19 54.53 94 54.53 91 58.16 89.19 58.16 92.19"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-265",
    points: "58.16 95.19 54.53 97.01 54.53 94 58.16 92.19 58.16 95.19"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.16 98.19 54.53 100.01 54.53 97.01 58.16 95.19 58.16 98.19"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-266",
    points: "58.16 101.2 54.53 103.01 54.53 100.01 58.16 98.19 58.16 101.2"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.16 104.2 54.53 106.01 54.53 103.01 58.16 101.2 58.16 104.2"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-267",
    points: "58.16 107.2 54.53 109.01 54.53 106.01 58.16 104.2 58.16 107.2"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.16 110.2 54.53 112.02 54.53 109.01 58.16 107.2 58.16 110.2"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-268",
    points: "58.16 113.2 54.53 115.02 54.53 112.02 58.16 110.2 58.16 113.2"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "58.16 116.2 54.53 118.02 54.53 115.02 58.16 113.2 58.16 116.2"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-269",
    points: "58.16 119.21 54.53 121.02 54.53 118.02 58.16 116.2 58.16 119.21"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 53.68,
    y: 54.68,
    width: 5.17,
    height: 10.33
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-271",
    d: "M45.26,41.84a26.52,26.52,0,0,0-7.57,15.9,2,2,0,0,1,.49-.06,2.08,2.08,0,1,1,0,4.16,2,2,0,0,1-.5-.06,24.2,24.2,0,0,0,7.91,15.56c0-15.83,9.67-15.83,9.67-15.83V58.34C44.59,56.84,45.26,41.84,45.26,41.84Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-272",
    d: "M45.26,41.84s-7.47,7.8-7.57,15.9l.49-.06S39.55,48,45.26,41.84Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-273",
    d: "M44.47,45.47s-4.25,6.12-4.63,10.75A5,5,0,0,1,40,63.59a22.74,22.74,0,0,0,4.25,10.63S40.22,57,44.47,45.47Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M55.15,121.43l11.77-8.83-2.86-3a15.33,15.33,0,0,1-2.55-5.22c-.17-.75-2.26-.51-1.34,2.75l.64,3.1-4.92-6.76s-2.63-4-3.15-2.59c-.33.88.54,3.09,1,3.62S57.12,111,57.12,111L53,105.89s-3-4-3.41-3.62c-1.71,1.61.32,4,.89,4.57s4.35,6.3,4.35,6.3l-5.7-5.46s-2.07-2.49-2.43-1.84c-.89,1.59.6,3.25.91,3.55.57.56,4.68,5.14,4.68,5.14l-1.69-.69s-4.65-3.18-4.8-2.74c-.75,2.18,7.46,8.4,7.46,8.4A22.85,22.85,0,0,0,55.15,121.43Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M67.5,160.82l-28.38-5.36s-5.61-.53-5.61-7.23V122.52L133.11,111s-25.12,37.51-33,44.21c-.88.75-4.92,1.63-9.88,2.48C80.63,159.33,67.5,160.82,67.5,160.82Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M133.11,111l-.9.11-1.3,3.11Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130.44,114.88,129,111.46l-.9.1,1.75,4.16Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M115.53,135.83l1.06-1.45-.23-.55Z"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M102.77,149.06l.82,2c1.22-1.38,2.57-3,4-4.83l-1.82-4.34Z"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "99.19 140.53 102.21 147.74 105.24 140.53 102.21 133.32 99.19 140.53"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.67,154.06c.67-.61,1.43-1.39,2.28-2.33l-.65-1.55Z"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M98.72,141.65l-3,7.21,2.7,6.42c.28-.09.54-.17.77-.26l2.58-6.16Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M112.87,125.54l-3,7.21,2.88,6.85.69-.92,2.48-5.93Z"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "112.31 124.22 109.29 117.01 106.26 124.22 109.29 131.43 112.31 124.22"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M106.35,141.08l1.84,4.39c1.26-1.59,2.58-3.3,3.92-5.08l-2.74-6.52Z"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "105.8 139.76 108.82 132.54 105.8 125.33 102.77 132.54 105.8 139.76"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "105.62 123.14 108.65 115.93 107.79 113.88 103.24 114.4 102.59 115.93 105.62 123.14"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "102.07 114.53 102.01 114.54 102.04 114.6 102.07 114.53"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "105.15 124.25 102.13 117.04 99.1 124.25 102.13 131.47 105.15 124.25"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "98.55 122.93 101.57 115.72 101.12 114.64 95.72 115.25 95.52 115.72 98.55 122.93"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "94.5 115.42 94.49 115.39 88.71 116.05 91.47 122.63 94.5 115.42"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "91 123.75 87.98 116.53 84.95 123.75 87.98 130.96 91 123.75"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "86.99 116.25 82.04 116.81 84.4 122.42 86.99 116.25"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "98.55 139.45 101.57 132.24 98.55 125.03 95.52 132.24 98.55 139.45"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "97.99 123.71 94.97 116.5 91.94 123.71 94.97 130.92 97.99 123.71"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "92.03 140.57 95.05 147.78 98.08 140.57 95.05 133.36 92.03 140.57"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "91.47 139.25 94.5 132.04 91.47 124.83 88.45 132.04 91.47 139.25"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M130.91,114.21l1.3-3.11-3.2.36,1.43,3.42Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M126.08,121.14c1.43-2,2.71-3.88,3.78-5.42l-1.75-4.16-2.25.26-1.85,4.4Z"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "119.96 123.12 122.99 115.91 121.48 112.32 118.29 112.68 116.94 115.91 119.96 123.12"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "117.13 112.81 115.7 112.98 116.38 114.59 117.13 112.81"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "119.49 124.24 116.47 117.03 113.44 124.24 116.47 131.45 119.49 124.24"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "112.89 122.91 115.91 115.7 114.81 113.08 110.77 113.54 109.86 115.7 112.89 122.91"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "124.88 111.93 122.32 112.22 123.54 115.13 124.88 111.93"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M120.43,124.2l1.29,3.09c1.34-1.87,2.62-3.68,3.81-5.37L123.46,117Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M116.94,132.53l.36.88c1.3-1.78,2.59-3.56,3.83-5.3L120,125.32Z"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "109.62 113.67 108.86 113.76 109.22 114.62 109.62 113.67"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M92.06,156.66c2.14-.38,4-.77,5.46-1.14L95,149.59Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84.34,157.89a1.81,1.81,0,0,0,.23,0l-.11-.25Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M80.88,149.08l-3,7.21,1,2.37,4.31-.6.75-1.77Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M76.74,158.94l1.22-.16-.57-1.38Z"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "88.51 148.51 91.53 155.72 94.56 148.51 91.53 141.3 88.51 148.51"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "87.95 132.77 84.93 139.97 87.95 147.18 90.98 139.97 87.95 132.77"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M88,149.62l-3,7.21.38.91c1.67-.25,3.32-.51,4.88-.77l.79-.13h0Z"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "81.44 148.3 84.46 155.51 87.49 148.3 84.46 141.09 81.44 148.3"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "87.31 131.68 84.29 124.47 81.26 131.68 84.29 138.89 87.31 131.68"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "80.71 130.36 83.73 123.15 81.12 116.92 80.26 117.02 77.68 123.15 80.71 130.36"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "80.79 147.22 83.82 140.01 80.79 132.8 77.77 140.01 80.79 147.22"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "80.24 131.48 77.21 124.27 74.19 131.48 77.21 138.69 80.24 131.48"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "73.16 131.17 70.14 123.96 67.11 131.17 70.14 138.38 73.16 131.17"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "66.56 129.85 69.58 122.64 67.82 118.43 65.17 118.73 63.53 122.64 66.56 129.85"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "66.64 146.71 69.67 139.5 66.64 132.29 63.62 139.5 66.64 146.71"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "66.09 130.97 63.06 123.76 60.04 130.97 63.06 138.18 66.09 130.97"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "79.29 117.13 75.33 117.58 77.21 122.07 79.29 117.13"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "73.72 130.4 76.74 123.19 74.43 117.68 72.93 117.85 70.69 123.19 73.72 130.4"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "71.77 117.98 68.66 118.34 70.14 121.87 71.77 117.98"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "74.19 148 77.21 155.21 80.24 148 77.21 140.79 74.19 148"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "73.63 146.67 76.66 139.47 73.63 132.26 70.61 139.47 73.63 146.67"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M73.72,149.11l-3,7.21L72,159.53l3.54-.44,1.16-2.77Z"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "67.11 147.79 70.14 155 73.16 147.79 70.14 140.58 67.11 147.79"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-274",
    d: "M88,158.56l5.6-1.29s-1.35-11.78-18.38-12.19S47,157.68,47,157.68l8,.88S67,151,75.26,152.4A24.26,24.26,0,0,1,88,158.56Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M73.69,198.84l19.74-1.57-.52-2.19,2.5-13.76-2.71-.72.38-3.12L90.78,176l.18-1.78s-2.55-1.07-1.06-2.57,2.8-4.4-4.3-4.8c-4.32-.24-6.53-2.25-2.91-8.44,0,.58-3-4-7.66-4.29-7.17-.42-17.14,3.2-17.14,3.2S73.35,193.1,73.69,198.84Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M92.43,194.76a2.3,2.3,0,0,0-1.24-2.92,12,12,0,0,0-2.75.84c-1.62.66-5.17.22-5.65-.35s1,3.29,6.62,1.61C92.88,192.91,92.43,194.76,92.43,194.76Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M91.47,191.35a6,6,0,0,0-3.27.08c-1.61.55-3.84.43-4.92-.57a9.2,9.2,0,0,0,4.3-.28s-.56-2,.66-2.2,1.3,2,1.3,2A3.17,3.17,0,0,1,91.47,191.35Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M76,199.38s-1.88-27.31,2.1-28.93c0,0,4.29-4.35,2.27-6.88-2.44-3-12.41-4.21-28.57-1.75,0,0-6.43,4.75,1.32,14,2.28,2.72,5.75,12.75,2.78,23.52Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.69,158.55l38.56-43-56.74,7v29.6a11.64,11.64,0,0,0,5.61,3.34C42.38,156.14,51.69,158.55,51.69,158.55Z"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "51.69 158.54 90.25 115.55 112.86 113.04 53.46 158.54 51.69 158.54"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M81.39,161.49l6.21-3.08s-5.32-7.9-15.08-7.36-17.58,7.36-17.58,7.36L59.65,161s6.37-4.49,13.46-4.63S81.39,161.49,81.39,161.49Z"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-276",
    points: "75.21 151.56 73.07 153.48 74.16 156.01 74.16 156.01 74.16 156.01 74.16 156.01 74.16 156.01 76.3 154.1 75.21 151.56 75.21 151.56 75.21 151.56 75.21 151.56 75.21 151.56"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-277",
    points: "70.27 151.65 68.75 154 70.53 156.19 70.53 156.19 70.53 156.19 70.53 156.19 70.53 156.19 72.05 153.84 70.27 151.65 70.27 151.65 70.27 151.65 70.27 151.65 70.27 151.65"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-278",
    points: "65.28 152.72 64.56 155.36 66.95 157 66.95 157 66.95 157 66.95 157 66.95 157 67.67 154.36 65.28 152.72 65.28 152.72 65.28 152.72 65.28 152.72 65.28 152.72"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-279",
    points: "61.52 154.27 61.07 156.96 63.62 158.4 63.62 158.4 63.62 158.4 63.62 158.4 63.62 158.4 64.07 155.71 61.52 154.27 61.52 154.27 61.52 154.27 61.52 154.27 61.52 154.27"
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-280",
    points: "79.98 152.98 77.36 154.3 77.67 157.01 77.67 157.01 77.67 157.01 77.67 157.01 77.67 157.01 80.28 155.68 79.98 152.98 79.98 152.98 79.98 152.98 79.98 152.98 79.98 152.98"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-281",
    points: "83.69 155.25 80.75 155.82 80.17 158.48 80.17 158.48 80.17 158.48 80.17 158.48 80.17 158.48 83.1 157.92 83.69 155.25 83.69 155.25 83.69 155.25 83.69 155.25 83.69 155.25"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M55.91,199.34s3-16.27-4.28-24.77-1-13.75,3.75-13.5c0,0-6.25,1.25-4.5,7.5S61.18,179.62,55.91,199.34Z"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M76,199.38s-2.16-24.55,2.1-28.93,3.77-6.88,1-8.38c0,0,1.91,3.37-1.5,7.5C71.63,176.82,76,199.38,76,199.38Z"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M70.38,198.32s-2.5-26-.5-28.5c0,0,2.25-7.25-.25-8.5,0,0,1,5-1.25,8.5S70.38,198.32,70.38,198.32Z"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M60.63,195.57s1-19.25-1.75-23-1.45-11.83.77-11.54c0,0-3,6.6.73,12C63.13,177.07,60.63,195.57,60.63,195.57Z"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    className: "cls-282",
    d: "M93.43,197.27s-26.3,2.92-37.68.55l-3.62,11s5.75-1.38,8,3.25c0,0,7.5-5.38,13.12,1.12,0,0,6.75-6.12,11.88-.12,0,0,6.37-7.75,12.37-1.88Z"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M93.63,197.82s-13,3.62-38.25,1l.38-1.88s21.76,1.88,37.36-.75Z"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    className: "cls-284",
    d: "M85.13,213.07s6.37-8.13,12.37-1.88l-4.37-15,2.62,12.5S89.63,205.82,85.13,213.07Z"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    className: "cls-285",
    d: "M73.25,213.19a10.54,10.54,0,0,0-13.12-1.12s-2.25-4.38-8-3.25c0,0,5.12-2.5,8.12,2.12C60.25,210.94,68,205.94,73.25,213.19Z"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M89.79,187.9s-1.63-2.33-4.5-.33C85.29,187.57,89,186.73,89.79,187.9Z"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M93.08,177.48a10.49,10.49,0,0,1-4.83-.16s-1-5.13-.25-5.63l1.9,0a5.3,5.3,0,0,0,1.73-4.09,6.61,6.61,0,0,1-2,.25l-4,1.37,1.12,8.63a4.14,4.14,0,0,0,3.5,1.5,13.16,13.16,0,0,1,2.5.25Z"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M93.14,157.14s-1.85-13.41-22.35-11.74l2.34-1.67s18.83-3.5,22.16,13Z"
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-287",
    points: "68.75 147.07 53.46 158.54 39 121.82 60.25 119.19 68.75 147.07"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-288"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-289",
    points: "54.66 125.18 55.37 123.46 54.66 121.73 53.95 123.46 54.66 125.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-290",
    points: "52.84 124.88 54.02 123.44 53.85 121.59 52.66 123.03 52.84 124.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-291",
    points: "51.18 124.06 52.74 123.04 53.12 121.21 51.56 122.23 51.18 124.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-292",
    points: "49.84 122.78 51.63 122.27 52.54 120.64 50.75 121.16 49.84 122.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-293",
    points: "48.94 121.17 50.8 121.21 52.15 119.92 50.29 119.88 48.94 121.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-294",
    points: "48.55 119.37 50.33 119.95 51.99 119.11 50.22 118.53 48.55 119.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-295",
    points: "48.72 117.53 50.24 118.61 52.07 118.3 50.55 117.22 48.72 117.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-296",
    points: "49.41 115.82 50.55 117.3 52.4 117.55 51.26 116.07 49.41 115.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-297",
    points: "50.59 114.39 51.23 116.14 52.93 116.92 52.28 115.17 50.59 114.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-298",
    points: "52.12 113.38 52.23 115.23 53.62 116.48 53.51 114.62 52.12 113.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-299",
    points: "53.9 112.85 53.45 114.66 54.41 116.26 54.85 114.45 53.9 112.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-300",
    points: "55.74 112.88 54.78 114.47 55.22 116.28 56.19 114.69 55.74 112.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-301",
    points: "57.5 113.45 56.11 114.69 56 116.55 57.39 115.31 57.5 113.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-302",
    points: "59.01 114.51 57.31 115.29 56.66 117.03 58.36 116.25 59.01 114.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-303",
    points: "60.14 115.97 58.29 116.21 57.16 117.69 59 117.44 60.14 115.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-304",
    points: "60.79 117.69 58.95 117.38 57.43 118.46 59.27 118.77 60.79 117.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-305",
    points: "60.9 119.54 59.24 118.7 57.47 119.28 59.13 120.12 60.9 119.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-306",
    points: "60.47 121.33 59.12 120.04 57.26 120.07 58.6 121.36 60.47 121.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-307",
    points: "59.52 122.92 58.62 121.28 56.83 120.77 57.73 122.39 59.52 122.92"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-308",
    points: "58.15 124.15 57.77 122.33 56.21 121.31 56.59 123.13 58.15 124.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-309",
    points: "56.47 124.93 56.65 123.08 55.47 121.64 55.29 123.49 56.47 124.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-310",
    points: "46.8 133.34 47.51 131.62 46.8 129.9 46.09 131.62 46.8 133.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-311",
    points: "44.98 133.04 46.17 131.61 46 129.75 44.81 131.19 44.98 133.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-312",
    points: "43.33 132.22 44.88 131.2 45.27 129.38 43.71 130.4 43.33 132.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-313",
    points: "41.99 130.95 43.78 130.43 44.68 128.8 42.89 129.32 41.99 130.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-314",
    points: "41.09 129.34 42.95 129.37 44.3 128.08 42.43 128.05 41.09 129.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-315",
    points: "40.7 127.53 42.47 128.12 44.13 127.28 42.37 126.7 40.7 127.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-316",
    points: "40.86 125.7 42.38 126.77 44.22 126.46 42.7 125.39 40.86 125.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-317",
    points: "41.56 123.98 42.7 125.46 44.54 125.71 43.41 124.23 41.56 123.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-318",
    points: "42.73 122.56 43.38 124.31 45.07 125.08 44.42 123.34 42.73 122.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-319",
    points: "44.27 121.54 44.37 123.4 45.76 124.64 45.66 122.78 44.27 121.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-320",
    points: "46.04 121.02 45.59 122.83 46.55 124.42 47 122.62 46.04 121.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-321",
    points: "47.89 121.04 46.92 122.64 47.37 124.45 48.33 122.85 47.89 121.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-322",
    points: "49.64 121.61 48.25 122.85 48.15 124.71 49.53 123.47 49.64 121.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-323",
    points: "51.15 122.67 49.46 123.45 48.81 125.19 50.5 124.42 51.15 122.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-324",
    points: "52.28 124.13 50.44 124.38 49.3 125.85 51.15 125.61 52.28 124.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-325",
    points: "52.93 125.86 51.1 125.55 49.58 126.62 51.41 126.93 52.93 125.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-326",
    points: "53.05 127.7 51.38 126.86 49.61 127.44 51.27 128.28 53.05 127.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-327",
    points: "52.61 129.5 51.27 128.2 49.41 128.23 50.75 129.53 52.61 129.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-328",
    points: "51.66 131.08 50.76 129.45 48.98 128.93 49.88 130.56 51.66 131.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-329",
    points: "50.29 132.32 49.91 130.49 48.36 129.47 48.74 131.29 50.29 132.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-330",
    points: "48.62 133.09 48.8 131.24 47.61 129.8 47.43 131.66 48.62 133.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-331",
    points: "43.26 122.51 43.97 120.79 43.26 119.06 42.54 120.79 43.26 122.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-332",
    points: "41.43 122.21 42.62 120.77 42.45 118.92 41.26 120.35 41.43 122.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-333",
    points: "39.78 121.39 41.34 120.37 41.72 118.54 40.16 119.56 39.78 121.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-334",
    points: "38.44 120.11 40.23 119.6 41.13 117.97 39.34 118.48 38.44 120.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-335",
    points: "37.54 118.5 39.4 118.54 40.75 117.25 38.88 117.21 37.54 118.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-336",
    points: "37.15 116.7 38.92 117.28 40.59 116.44 38.82 115.86 37.15 116.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-337",
    points: "37.31 114.86 38.84 115.94 40.67 115.63 39.15 114.55 37.31 114.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-338",
    points: "38.01 113.15 39.15 114.63 40.99 114.88 39.86 113.4 38.01 113.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-339",
    points: "39.18 111.72 39.83 113.47 41.52 114.25 40.88 112.5 39.18 111.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-340",
    points: "40.72 110.7 40.83 112.56 42.21 113.81 42.11 111.95 40.72 110.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-341",
    points: "42.49 110.18 42.05 111.99 43 113.59 43.45 111.78 42.49 110.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-342",
    points: "44.34 110.21 43.38 111.81 43.82 113.61 44.78 112.02 44.34 110.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-343",
    points: "46.09 110.78 44.71 112.02 44.6 113.88 45.99 112.64 46.09 110.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-344",
    points: "47.6 111.84 45.91 112.61 45.26 114.36 46.95 113.58 47.6 111.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-345",
    points: "48.74 113.3 46.89 113.54 45.75 115.02 47.6 114.77 48.74 113.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-346",
    points: "49.39 115.02 47.55 114.71 46.03 115.79 47.87 116.1 49.39 115.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-347",
    points: "49.5 116.87 47.84 116.03 46.07 116.61 47.73 117.45 49.5 116.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-348",
    points: "49.06 118.66 47.72 117.37 45.86 117.4 47.2 118.69 49.06 118.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-349",
    points: "48.12 120.25 47.22 118.61 45.43 118.09 46.33 119.72 48.12 120.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-350",
    points: "46.75 121.48 46.37 119.66 44.81 118.64 45.19 120.46 46.75 121.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-351",
    points: "45.07 122.26 45.25 120.41 44.06 118.97 43.89 120.82 45.07 122.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-352",
    points: "51.3 114.46 52.01 112.73 51.3 111.01 50.59 112.73 51.3 114.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-353",
    points: "49.48 114.16 50.66 112.72 50.49 110.87 49.3 112.3 49.48 114.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-354",
    points: "47.82 113.34 49.38 112.31 49.76 110.49 48.21 111.51 47.82 113.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-355",
    points: "46.49 112.06 48.28 111.55 49.18 109.92 47.39 110.43 46.49 112.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-356",
    points: "45.59 110.45 47.45 110.49 48.79 109.2 46.93 109.16 45.59 110.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-357",
    points: "45.2 108.65 46.97 109.23 48.63 108.39 46.86 107.81 45.2 108.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-358",
    points: "45.36 106.81 46.88 107.89 48.72 107.58 47.2 106.5 45.36 106.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-359",
    points: "46.06 105.1 47.19 106.58 49.04 106.83 47.9 105.35 46.06 105.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-360",
    points: "47.23 103.67 47.88 105.42 49.57 106.2 48.92 104.45 47.23 103.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-361",
    points: "48.77 102.65 48.87 104.51 50.26 105.76 50.15 103.9 48.77 102.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-362",
    points: "50.54 102.13 50.09 103.94 51.05 105.54 51.5 103.73 50.54 102.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-363",
    points: "52.38 102.16 51.42 103.75 51.87 105.56 52.83 103.97 52.38 102.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-364",
    points: "54.14 102.73 52.75 103.97 52.64 105.83 54.03 104.59 54.14 102.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-365",
    points: "55.65 103.79 53.96 104.56 53.3 106.31 55 105.53 55.65 103.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-366",
    points: "56.78 105.25 54.93 105.49 53.8 106.97 55.64 106.72 56.78 105.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-367",
    points: "57.43 106.97 55.59 106.66 54.07 107.74 55.91 108.05 57.43 106.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-368",
    points: "57.54 108.82 55.88 107.98 54.11 108.56 55.77 109.39 57.54 108.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-369",
    points: "57.11 110.61 55.77 109.32 53.9 109.35 55.24 110.64 57.11 110.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-370",
    points: "56.16 112.2 55.26 110.56 53.47 110.04 54.37 111.68 56.16 112.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-371",
    points: "54.79 113.43 54.41 111.61 52.85 110.58 53.23 112.41 54.79 113.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-372",
    points: "53.12 114.21 53.29 112.35 52.11 110.92 51.93 112.77 53.12 114.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-373",
    points: "57.98 136.06 58.7 134.34 57.98 132.62 57.27 134.34 57.98 136.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-374",
    points: "56.16 135.77 57.35 134.33 57.18 132.48 55.99 133.91 56.16 135.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-375",
    points: "54.51 134.95 56.07 133.92 56.45 132.1 54.89 133.12 54.51 134.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-376",
    points: "53.17 133.67 54.96 133.16 55.87 131.53 54.08 132.04 53.17 133.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-377",
    points: "52.27 132.06 54.13 132.1 55.48 130.81 53.61 130.77 52.27 132.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-378",
    points: "51.88 130.26 53.65 130.84 55.32 130 53.55 129.42 51.88 130.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-379",
    points: "52.05 128.42 53.56 129.5 55.4 129.19 53.88 128.11 52.05 128.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-380",
    points: "52.74 126.71 53.88 128.19 55.72 128.43 54.59 126.95 52.74 126.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-381",
    points: "53.91 125.28 54.56 127.03 56.25 127.81 55.6 126.06 53.91 125.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-382",
    points: "55.45 124.26 55.55 126.12 56.94 127.36 56.84 125.5 55.45 124.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-383",
    points: "57.22 123.74 56.77 125.55 57.73 127.15 58.18 125.34 57.22 123.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-384",
    points: "59.07 123.77 58.11 125.36 58.55 127.17 59.51 125.58 59.07 123.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-385",
    points: "60.83 124.33 59.44 125.58 59.33 127.43 60.72 126.19 60.83 124.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-386",
    points: "62.34 125.39 60.64 126.17 59.99 127.92 61.68 127.14 62.34 125.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-387",
    points: "63.47 126.85 61.62 127.1 60.48 128.57 62.33 128.33 63.47 126.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-388",
    points: "64.12 128.58 62.28 128.27 60.76 129.34 62.59 129.66 64.12 128.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-389",
    points: "64.23 130.42 62.56 129.58 60.8 130.16 62.46 131 64.23 130.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-390",
    points: "63.79 132.22 62.45 130.92 60.59 130.96 61.93 132.25 63.79 132.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-391",
    points: "62.85 133.8 61.95 132.17 60.16 131.65 61.06 133.28 62.85 133.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-392",
    points: "61.48 135.04 61.1 133.22 59.54 132.19 59.92 134.01 61.48 135.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-393",
    points: "59.8 135.82 59.98 133.96 58.79 132.53 58.62 134.38 59.8 135.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-394",
    points: "49.93 144.78 50.64 143.05 49.93 141.33 49.22 143.05 49.93 144.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-395",
    points: "48.1 144.48 49.29 143.04 49.12 141.19 47.93 142.62 48.1 144.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-396",
    points: "46.45 143.66 48.01 142.63 48.39 140.81 46.84 141.83 46.45 143.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-397",
    points: "45.12 142.38 46.91 141.86 47.81 140.24 46.02 140.75 45.12 142.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-398",
    points: "44.21 140.77 46.08 140.81 47.42 139.52 45.56 139.48 44.21 140.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-399",
    points: "43.83 138.97 45.6 139.55 47.26 138.71 45.49 138.13 43.83 138.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-400",
    points: "43.99 137.13 45.51 138.21 47.34 137.9 45.83 136.82 43.99 137.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-401",
    points: "44.69 135.42 45.82 136.9 47.67 137.14 46.53 135.66 44.69 135.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-402",
    points: "45.86 133.99 46.5 135.74 48.2 136.52 47.55 134.77 45.86 133.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-403",
    points: "47.4 132.97 47.5 134.83 48.89 136.07 48.78 134.21 47.4 132.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-404",
    points: "49.17 132.45 48.72 134.26 49.68 135.86 50.13 134.05 49.17 132.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-405",
    points: "51.01 132.47 50.05 134.07 50.49 135.88 51.46 134.29 51.01 132.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-406",
    points: "52.77 133.04 51.38 134.29 51.27 136.15 52.66 134.91 52.77 133.04"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-407",
    points: "54.28 134.11 52.59 134.88 51.93 136.63 53.63 135.85 54.28 134.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-408",
    points: "55.41 135.56 53.56 135.81 52.43 137.28 54.27 137.04 55.41 135.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-409",
    points: "56.06 137.29 54.22 136.98 52.7 138.06 54.54 138.37 56.06 137.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-410",
    points: "56.17 139.13 54.51 138.29 52.74 138.87 54.4 139.71 56.17 139.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-411",
    points: "55.74 140.93 54.4 139.63 52.53 139.66 53.87 140.96 55.74 140.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-412",
    points: "54.79 142.51 53.89 140.88 52.1 140.36 53 141.99 54.79 142.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-413",
    points: "53.42 143.75 53.04 141.93 51.48 140.9 51.86 142.72 53.42 143.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-414",
    points: "51.74 144.53 51.92 142.67 50.73 141.24 50.56 143.09 51.74 144.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-415",
    points: "64.94 157.87 65.66 156.15 64.94 154.42 64.23 156.15 64.94 157.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-416",
    points: "63.12 157.57 64.31 156.13 64.14 154.28 62.95 155.72 63.12 157.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-417",
    points: "61.47 156.75 63.03 155.72 63.41 153.9 61.85 154.92 61.47 156.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-418",
    points: "60.13 155.47 61.92 154.96 62.82 153.33 61.03 153.84 60.13 155.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-419",
    points: "59.23 153.86 61.09 153.9 62.44 152.61 60.57 152.57 59.23 153.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-420",
    points: "58.84 152.06 60.61 152.64 62.28 151.8 60.51 151.22 58.84 152.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-421",
    points: "59.01 150.22 60.52 151.3 62.36 150.99 60.84 149.91 59.01 150.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-422",
    points: "59.7 148.51 60.84 149.99 62.68 150.24 61.55 148.76 59.7 148.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-423",
    points: "60.87 147.08 61.52 148.83 63.21 149.61 62.56 147.86 60.87 147.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-424",
    points: "62.41 146.06 62.52 147.92 63.9 149.17 63.8 147.31 62.41 146.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-425",
    points: "64.18 145.54 63.73 147.35 64.69 148.95 65.14 147.14 64.18 145.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-426",
    points: "66.03 145.57 65.07 147.16 65.51 148.97 66.47 147.38 66.03 145.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-427",
    points: "67.78 146.13 66.39 147.38 66.29 149.24 67.68 148 67.78 146.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-428",
    points: "69.3 147.2 67.6 147.97 66.95 149.72 68.64 148.94 69.3 147.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-429",
    points: "70.43 148.66 68.58 148.9 67.44 150.37 69.29 150.13 70.43 148.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-430",
    points: "71.08 150.38 69.24 150.07 67.72 151.15 69.55 151.46 71.08 150.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-431",
    points: "71.19 152.23 69.53 151.39 67.75 151.97 69.42 152.81 71.19 152.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-432",
    points: "70.75 154.02 69.41 152.73 67.55 152.76 68.89 154.05 70.75 154.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-433",
    points: "69.81 155.61 68.91 153.97 67.12 153.45 68.02 155.08 69.81 155.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-434",
    points: "68.44 156.84 68.06 155.02 66.5 154 66.88 155.82 68.44 156.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-435",
    points: "66.76 157.62 66.94 155.76 65.75 154.33 65.58 156.18 66.76 157.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-436",
    points: "57.09 166.03 57.8 164.31 57.09 162.59 56.38 164.31 57.09 166.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-437",
    points: "55.27 165.73 56.45 164.3 56.28 162.44 55.09 163.88 55.27 165.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-438",
    points: "53.61 164.91 55.17 163.89 55.55 162.07 54 163.09 53.61 164.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-439",
    points: "52.28 163.64 54.07 163.12 54.97 161.49 53.18 162.01 52.28 163.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-440",
    points: "51.38 162.03 53.24 162.06 54.58 160.77 52.72 160.74 51.38 162.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-441",
    points: "50.99 160.22 52.76 160.81 54.42 159.97 52.65 159.38 50.99 160.22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-442",
    points: "51.15 158.38 52.67 159.46 54.51 159.15 52.99 158.07 51.15 158.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-443",
    points: "51.85 156.67 52.98 158.15 54.83 158.4 53.69 156.92 51.85 156.67"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-444",
    points: "53.02 155.25 53.67 156.99 55.36 157.77 54.71 156.03 53.02 155.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-445",
    points: "54.56 154.23 54.66 156.09 56.05 157.33 55.94 155.47 54.56 154.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-446",
    points: "56.33 153.71 55.88 155.51 56.84 157.11 57.29 155.31 56.33 153.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-447",
    points: "58.17 153.73 57.21 155.33 57.66 157.14 58.62 155.54 58.17 153.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-448",
    points: "59.93 154.3 58.54 155.54 58.43 157.4 59.82 156.16 59.93 154.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-449",
    points: "61.44 155.36 59.75 156.14 59.09 157.88 60.79 157.11 61.44 155.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-450",
    points: "62.57 156.82 60.72 157.06 59.59 158.54 61.43 158.3 62.57 156.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-451",
    points: "63.22 158.55 61.38 158.24 59.86 159.31 61.7 159.62 63.22 158.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-452",
    points: "63.33 160.39 61.67 159.55 59.9 160.13 61.56 160.97 63.33 160.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-453",
    points: "62.9 162.18 61.56 160.89 59.69 160.92 61.03 162.22 62.9 162.18"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-454",
    points: "61.95 163.77 61.05 162.14 59.26 161.62 60.16 163.25 61.95 163.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-455",
    points: "60.58 165.01 60.2 163.18 58.65 162.16 59.02 163.98 60.58 165.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-456",
    points: "58.91 165.78 59.08 163.93 57.9 162.49 57.72 164.35 58.91 165.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-457",
    points: "53.54 155.2 54.25 153.47 53.54 151.75 52.83 153.47 53.54 155.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-458",
    points: "51.72 154.9 52.91 153.46 52.73 151.61 51.55 153.04 51.72 154.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-459",
    points: "50.07 154.08 51.63 153.06 52.01 151.23 50.45 152.25 50.07 154.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-460",
    points: "48.73 152.8 50.52 152.29 51.42 150.66 49.63 151.17 48.73 152.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-461",
    points: "47.83 151.19 49.69 151.23 51.03 149.94 49.17 149.9 47.83 151.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-462",
    points: "47.44 149.39 49.21 149.97 50.87 149.13 49.1 148.55 47.44 149.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-463",
    points: "47.6 147.55 49.12 148.63 50.96 148.32 49.44 147.24 47.6 147.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-464",
    points: "48.3 145.84 49.43 147.32 51.28 147.56 50.15 146.09 48.3 145.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-465",
    points: "49.47 144.41 50.12 146.16 51.81 146.94 51.16 145.19 49.47 144.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-466",
    points: "51.01 143.39 51.11 145.25 52.5 146.5 52.4 144.63 51.01 143.39"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-467",
    points: "52.78 142.87 52.33 144.68 53.29 146.28 53.74 144.47 52.78 142.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-468",
    points: "54.63 142.9 53.66 144.5 54.11 146.3 55.07 144.71 54.63 142.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-469",
    points: "56.38 143.47 54.99 144.71 54.88 146.57 56.27 145.32 56.38 143.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-470",
    points: "57.89 144.53 56.2 145.3 55.55 147.05 57.24 146.27 57.89 144.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-471",
    points: "59.02 145.99 57.18 146.23 56.04 147.7 57.89 147.46 59.02 145.99"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-472",
    points: "59.67 147.71 57.84 147.4 56.32 148.47 58.15 148.79 59.67 147.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-473",
    points: "59.79 149.56 58.12 148.72 56.35 149.29 58.01 150.13 59.79 149.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-474",
    points: "59.35 151.35 58.01 150.06 56.15 150.09 57.49 151.38 59.35 151.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-475",
    points: "58.4 152.94 57.5 151.3 55.72 150.78 56.62 152.41 58.4 152.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-476",
    points: "57.03 154.17 56.65 152.35 55.1 151.32 55.48 153.15 57.03 154.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-477",
    points: "55.36 154.95 55.53 153.09 54.35 151.66 54.17 153.51 55.36 154.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-478",
    points: "61.59 147.15 62.3 145.42 61.59 143.7 60.87 145.42 61.59 147.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-479",
    points: "59.76 146.85 60.95 145.41 60.78 143.56 59.59 144.99 59.76 146.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-480",
    points: "58.11 146.03 59.67 145 60.05 143.18 58.49 144.2 58.11 146.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-481",
    points: "56.77 144.75 58.56 144.24 59.47 142.61 57.68 143.12 56.77 144.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-482",
    points: "55.87 143.14 57.73 143.18 59.08 141.88 57.22 141.85 55.87 143.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-483",
    points: "55.48 141.34 57.26 141.92 58.92 141.08 57.15 140.5 55.48 141.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-484",
    points: "55.65 139.5 57.17 140.58 59 140.27 57.48 139.19 55.65 139.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-485",
    points: "56.34 137.79 57.48 139.27 59.33 139.51 58.19 138.04 56.34 137.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-486",
    points: "57.51 136.36 58.16 138.11 59.85 138.89 59.21 137.14 57.51 136.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-487",
    points: "59.05 135.34 59.16 137.2 60.55 138.45 60.44 136.59 59.05 135.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-488",
    points: "60.82 134.82 60.38 136.63 61.34 138.23 61.78 136.42 60.82 134.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-489",
    points: "62.67 134.85 61.71 136.44 62.15 138.25 63.12 136.66 62.67 134.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-490",
    points: "64.43 135.42 63.04 136.66 62.93 138.52 64.32 137.28 64.43 135.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-491",
    points: "65.94 136.48 64.24 137.25 63.59 139 65.29 138.22 65.94 136.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-492",
    points: "67.07 137.94 65.22 138.18 64.08 139.66 65.93 139.41 67.07 137.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-493",
    points: "67.72 139.66 65.88 139.35 64.36 140.43 66.2 140.74 67.72 139.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-494",
    points: "67.83 141.51 66.17 140.66 64.4 141.25 66.06 142.08 67.83 141.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-495",
    points: "67.39 143.3 66.05 142.01 64.19 142.04 65.53 143.33 67.39 143.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-496",
    points: "66.45 144.88 65.55 143.25 63.76 142.73 64.66 144.37 66.45 144.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-497",
    points: "65.08 146.12 64.7 144.3 63.14 143.27 63.52 145.1 65.08 146.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-498",
    points: "63.4 146.9 63.58 145.04 62.39 143.61 62.22 145.46 63.4 146.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-499",
    points: "68.27 168.75 68.98 167.03 68.27 165.31 67.56 167.03 68.27 168.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-500",
    points: "66.45 168.46 67.64 167.02 67.47 165.16 66.28 166.6 66.45 168.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-501",
    points: "64.8 167.63 66.35 166.61 66.74 164.79 65.18 165.81 64.8 167.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-502",
    points: "63.46 166.36 65.25 165.84 66.15 164.22 64.36 164.73 63.46 166.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-503",
    points: "62.56 164.75 64.42 164.79 65.76 163.5 63.9 163.46 62.56 164.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-504",
    points: "62.17 162.95 63.94 163.53 65.6 162.69 63.84 162.11 62.17 162.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-505",
    points: "62.33 161.11 63.85 162.19 65.69 161.88 64.17 160.8 62.33 161.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-506",
    points: "63.03 159.4 64.16 160.88 66.01 161.12 64.88 159.65 63.03 159.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-507",
    points: "64.2 157.97 64.85 159.72 66.54 160.5 65.89 158.75 64.2 157.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-508",
    points: "65.74 156.95 65.84 158.81 67.23 160.05 67.13 158.19 65.74 156.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-509",
    points: "67.51 156.43 67.06 158.24 68.02 159.84 68.47 158.03 67.51 156.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-510",
    points: "69.36 156.45 68.39 158.05 68.84 159.86 69.8 158.27 69.36 156.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-511",
    points: "71.11 157.02 69.72 158.27 69.61 160.12 71 158.88 71.11 157.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-512",
    points: "72.62 158.08 70.93 158.86 70.28 160.61 71.97 159.83 72.62 158.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-513",
    points: "73.75 159.54 71.91 159.79 70.77 161.26 72.62 161.02 73.75 159.54"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-514",
    points: "74.4 161.27 72.57 160.96 71.05 162.03 72.88 162.35 74.4 161.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-515",
    points: "74.52 163.11 72.85 162.27 71.08 162.85 72.75 163.69 74.52 163.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-516",
    points: "74.08 164.91 72.74 163.61 70.88 163.65 72.22 164.94 74.08 164.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-517",
    points: "73.13 166.49 72.23 164.86 70.45 164.34 71.34 165.97 73.13 166.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-518",
    points: "71.76 167.73 71.38 165.91 69.83 164.88 70.21 166.7 71.76 167.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-519",
    points: "70.09 168.51 70.26 166.65 69.08 165.21 68.9 167.07 70.09 168.51"
  }))), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "68.75 146.94 60.25 119.07 62.13 119.07 70.8 145.4 68.75 146.94"
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-520",
    points: "75.3 141.9 70.8 145.4 62.13 119.07 66.96 118.57 75.3 141.9"
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "79.1 132.57 76.22 132.72 75.38 135.23 75.38 135.23 75.38 135.23 75.38 135.23 75.38 135.23 78.26 135.09 79.1 132.57 79.1 132.57 79.1 132.57 79.1 132.57 79.1 132.57"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "83.31 129.57 80.43 129.72 79.59 132.23 79.59 132.23 79.59 132.23 79.59 132.23 79.59 132.23 82.47 132.09 83.31 129.57 83.31 129.57 83.31 129.57 83.31 129.57 83.31 129.57"
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "87.52 126.58 84.64 126.72 83.8 129.23 83.8 129.23 83.8 129.23 83.8 129.23 83.8 129.23 86.68 129.09 87.52 126.58 87.52 126.58 87.52 126.58 87.52 126.58 87.52 126.58"
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "91.35 123.82 88.47 123.97 87.63 126.48 87.63 126.48 87.63 126.48 87.63 126.48 87.63 126.48 90.51 126.34 91.35 123.82 91.35 123.82 91.35 123.82 91.35 123.82 91.35 123.82"
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "95.56 120.83 92.68 120.97 91.84 123.48 91.84 123.48 91.84 123.48 91.84 123.48 91.84 123.48 94.72 123.34 95.56 120.83 95.56 120.83 95.56 120.83 95.56 120.83 95.56 120.83"
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "99.77 117.83 96.89 117.97 96.05 120.48 96.05 120.48 96.05 120.48 96.05 120.48 96.05 120.48 98.93 120.34 99.77 117.83 99.77 117.83 99.77 117.83 99.77 117.83 99.77 117.83"
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "75.3 141.98 114.55 112.9 110.43 113.23 74.55 139.82 75.3 141.98"
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.96 184.02 111.59 182.21 111.59 185.21 107.96 187.02 107.96 184.02"
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-521",
    points: "107.96 181.02 111.59 179.21 111.59 182.21 107.96 184.02 107.96 181.02"
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.96 178.02 111.59 176.2 111.59 179.21 107.96 181.02 107.96 178.02"
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-522",
    points: "107.96 175.02 111.59 173.2 111.59 176.2 107.96 178.02 107.96 175.02"
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.96 172.01 111.59 170.2 111.59 173.2 107.96 175.02 107.96 172.01"
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-523",
    points: "107.96 169.01 111.59 167.2 111.59 170.2 107.96 172.01 107.96 169.01"
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.96 166.01 111.59 164.2 111.59 167.2 107.96 169.01 107.96 166.01"
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-524",
    points: "107.96 163.01 111.59 161.19 111.59 164.2 107.96 166.01 107.96 163.01"
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.96 160.01 111.59 158.19 111.59 161.19 107.96 163.01 107.96 160.01"
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-525",
    points: "107.96 157 111.59 155.19 111.59 158.19 107.96 160.01 107.96 157"
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.96 154 111.59 152.19 111.59 155.19 107.96 157 107.96 154"
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-526",
    points: "107.96 151 111.59 149.19 111.59 152.19 107.96 154 107.96 151"
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.96 148 111.59 146.18 111.59 149.19 107.96 151 107.96 148"
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-527",
    points: "107.96 145 111.59 143.18 111.59 146.18 107.96 148 107.96 145"
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.96 142 111.59 140.18 111.59 143.18 107.96 145 107.96 142"
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-528",
    points: "107.96 139 111.59 137.18 111.59 140.18 107.96 142 107.96 139"
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.96 135.99 111.59 134.18 111.59 137.18 107.96 139 107.96 135.99"
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-529",
    points: "107.96 132.99 111.59 131.18 111.59 134.18 107.96 135.99 107.96 132.99"
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.96 129.99 111.59 128.17 111.59 131.18 107.96 132.99 107.96 129.99"
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-530",
    points: "107.96 126.99 111.59 125.17 111.59 128.17 107.96 129.99 107.96 126.99"
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.96 123.98 111.59 122.17 111.59 125.17 107.96 126.99 107.96 123.98"
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-531",
    points: "107.96 120.98 111.59 119.17 111.59 122.17 107.96 123.98 107.96 120.98"
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "107.96 117.98 111.59 116.17 111.59 119.17 107.96 120.98 107.96 117.98"
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-532",
    points: "107.96 114.98 111.59 113.16 111.59 116.17 107.96 117.98 107.96 114.98"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-533",
    x: 107.27,
    y: 169.18,
    width: 5.17,
    height: 10.33
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    className: "cls-534",
    d: "M120.86,192.34a26.47,26.47,0,0,0,7.57-15.89,2.63,2.63,0,0,1-.49.06,2.09,2.09,0,1,1,.5-4.1,24.24,24.24,0,0,0-7.91-15.57c0,15.84-9.67,15.84-9.67,15.84v3.16C121.52,177.34,120.86,192.34,120.86,192.34Z"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    className: "cls-535",
    d: "M120.86,192.34s7.47-7.79,7.57-15.89l-.49.06S126.57,186.22,120.86,192.34Z"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    className: "cls-536",
    d: "M121.65,188.72s4.25-6.13,4.62-10.75a5,5,0,0,1-.12-7.38A22.85,22.85,0,0,0,121.9,160S125.9,177.22,121.65,188.72Z"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M111,112.75,99.2,121.58l2.86,3a15.53,15.53,0,0,1,2.55,5.22c.16.74,2.26.51,1.34-2.75l-.64-3.1,4.92,6.76s2.63,4,3.15,2.59c.33-.89-.54-3.09-1-3.63s-3.37-6.48-3.37-6.48l4.1,5.11s3,4.05,3.4,3.63c1.72-1.61-.31-4-.88-4.58s-4.35-6.3-4.35-6.3l5.69,5.47s2.08,2.49,2.44,1.83c.88-1.59-.6-3.24-.91-3.55-.57-.56-4.68-5.13-4.68-5.13l1.68.69s4.66,3.18,4.81,2.74c.75-2.18-7.46-8.4-7.46-8.4A22,22,0,0,0,111,112.75Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg13D);
export default __webpack_public_path__ + "static/media/13_d.e709fd62c3ebdd1a98eecc4e4f635fa4.svg";
export { ForwardRef as ReactComponent };